import { useState, useRef, useEffect, SetStateAction } from "react";
import {
  createProject,
  useClientList,
  useAssignees,
  ProjectForm,
  ClientProjects,
  Project,
  useProjectsList,
  useTaskStatus,
  useProjectFilterAssignees,
  useProjectAssignees,
  TaskType,
  useTaskList,
  AssigneeType,
  SubTask,
  TaskForm,
  createTask,
  updateTask,
  useTaskListTotal,
  useProjectDetails,
  updateProject,
  updateSubTask,
  deleteTask,
  useUserProjects,
  createLogTime,
  useTaskEstimation,
  TaskTotalType,
  useTaskHistoryById,
  useFullTaskListByProjectId,
} from "./api";
import CreateButton from "../../components/CreateButton";
import { Dropdown } from "primereact/dropdown";
import {
  Formik,
  Form,
  Field,
  useField,
  useFormikContext,
  FieldArray,
  ErrorMessage,
} from "formik";
import * as Yup from "yup";
import { convertJSONtoCSV, dateBeautify } from "../../helpers/utils";
import { Editor } from "primereact/editor";
import { TabView, TabPanel } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import TimeRange from "react-time-range";
import { MultiSelect } from "primereact/multiselect";
import { RadioButton } from "primereact/radiobutton";
import inProgress from "../../assets/images/in-progress.svg";
import inReview from "../../assets/images/in-review.svg";
import hold from "../../assets/images/hold.svg";
import done from "../../assets/images/green_status_circle.svg";
import open from "../../assets/images/gray_status_circle.svg";
import backlog from "../../assets/images/gray_status_circle.svg";
import devCompleted from "../../assets/images/purple_status_circle.svg";
import qAProduction from "../../assets/images/purple_status_circle.svg";
import stagging from "../../assets/images/purple_status_circle.svg";
import qAStagging from "../../assets/images/purple_status_circle.svg";
import priorityHigh from "../../assets/images/priority_high.svg";
import priorityMedium from "../../assets/images/priority_medium.svg";
import priorityLow from "../../assets/images/priority_low.svg";
import moment from "moment";
import { Checkbox } from "primereact/checkbox";
import DataLoading from "../../components/DataLoading";
import { Toast } from "primereact/toast";
import { checkPermission, hasPermission } from "../../helpers/common";
import { getPermissionsList } from "../../helpers/getPermission";
import { confirmDialog } from "primereact/confirmdialog";
import DataEmpty from "../../components/DataEmpty";
import { Button } from "primereact/button";
import { useParams } from "react-router-dom";
import { isConstructorDeclaration } from "typescript";
import DefaultImage from "../../profile_images/DefaultImage";

type ProjectItemContainerProps = ClientProjects & {
  selectProject: React.Dispatch<React.SetStateAction<string | undefined>>;
  selectProjectName: React.Dispatch<React.SetStateAction<string | undefined>>;
  projectId: string | undefined;
  setSelectedSort: React.Dispatch<React.SetStateAction<string>>;
  setSelectedStatus: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedAssignee: React.Dispatch<React.SetStateAction<string[]>>;
};

type ProjectItemProps = Project & {
  selectProject: React.Dispatch<React.SetStateAction<string | undefined>>;
  selectProjectName: React.Dispatch<React.SetStateAction<string | undefined>>;
  projectId: string | undefined;
  setSelectedSort: React.Dispatch<React.SetStateAction<string>>;
  setSelectedStatus: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedAssignee: React.Dispatch<React.SetStateAction<string[]>>;
};

const taskStatusIcons: any = {
  InProgress: inProgress,
  InReview: inReview,
  Hold: hold,
  Done: done,
  Open: open,
  Backlog: backlog,
  DevCompleted: devCompleted,
  QAProduction: qAProduction,
  Stagging: stagging,
  QAStagging: qAStagging,
};

const priorityIcons: any = {
  High: priorityHigh,
  Medium: priorityMedium,
  Low: priorityLow,
};

const ProjectItem: React.FC<ProjectItemProps> = ({
  _id,
  name,
  selectProject,
  selectProjectName,
  projectId,
  setSelectedSort,
  setSelectedStatus,
  setSelectedAssignee,
}) => {
  const handleClick = (_id: string) => {
    selectProject(_id);
    selectProjectName(name);
    setSelectedStatus([]);
    setSelectedSort("Default");
    setSelectedAssignee([]);
  };

  return (
    <div
      className={`d-flex task-name ${_id === projectId ? "clicked" : ""}`}
      onClick={() => handleClick(_id)}
    >
      <div className="d-flex">
        <span className="material-icons-outlined">folder_open</span>
        <p>{name}</p>
      </div>
      <div className="arr-ryt">
        <span className="material-icons-round">keyboard_arrow_right</span>
      </div>
    </div>
  );
};

const ProjectItemContainer: React.FC<ProjectItemContainerProps> = ({
  setSelectedSort,
  setSelectedStatus,
  setSelectedAssignee,
  clientName,
  projects,
  selectProject,
  selectProjectName,
  projectId,
}) => {
  useEffect(() => {
    selectProject(projects?.[0]?._id);
    selectProjectName(projects?.[0]?.name);
  }, []);
  return (
    <div className="col-bd-ele">
      <div className="pro-name">{clientName}</div>
      <div className="tasks">
        {projects?.map((project) => (
          <ProjectItem
            key={project?._id}
            {...project}
            selectProject={selectProject}
            selectProjectName={selectProjectName}
            projectId={projectId}
            setSelectedSort={setSelectedSort}
            setSelectedStatus={setSelectedStatus}
            setSelectedAssignee={setSelectedAssignee}
          />
        ))}
      </div>
    </div>
  );
};

const openProjectModal = (
  role: string,
  user: string,
  setIsProjectUpdate: React.Dispatch<React.SetStateAction<boolean>>,
  createProject: () => void,
  setInputField: React.Dispatch<React.SetStateAction<ProjectForm>>
) => {
  setIsProjectUpdate(false);
  let projectForm: ProjectForm = {
    _id: "",
    project_name: "",
    project_tag: "",
    client: "",
    duration: "",
    duration_type: "",
    due_date: "",
    status: "",
    project_type: "",
    description: "",
    manager: role === "Manager" ? user : "",
    leader: role === "Leader" ? user : "",
    techLeader: "",
    estimate_start_date: "",
    estimate_end_date: "",
    actual_start_date: "",
    actual_end_date: "",
    estimate_time: "",
    actual_time: "",
    estimate_time_type: "",
    actual_time_type: "",
    sprint_tag: "",
    contributors: [],
    assignees_visibility: true,
    contributor: "",
  };
  setInputField(projectForm);
  createProject();
};

const Nav = ({
  role,
  user,
  projectsList,
  permissions,
  isProjectLoading,
  createProject,
  selectProject,
  setSelectedSort,
  setSelectedStatus,
  setSelectedAssignee,
  selectProjectName,
  projectId,
  setInputField,
  setIsProjectUpdate,
}: {
  role: string;
  user: string;
  projectsList: ClientProjects[] | undefined;
  isProjectLoading: boolean;
  createProject: () => void;
  selectProject: React.Dispatch<React.SetStateAction<string | undefined>>;
  permissions: any;
  selectProjectName: React.Dispatch<React.SetStateAction<string | undefined>>;
  projectId: string | undefined;
  setInputField: React.Dispatch<React.SetStateAction<ProjectForm>>;
  setIsProjectUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedSort: React.Dispatch<React.SetStateAction<string>>;
  setSelectedStatus: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedAssignee: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
  const [toggleNav, setToggleNav] = useState("open");

  const openNav = () =>
    setToggleNav((state) => (state === "open" ? "close" : "open"));
  if (isProjectLoading) {
    return <DataLoading />;
  }

  return (
    <div className="collapse-box-wrap">
      <div className={`collapse-box ${toggleNav}`}>
        <div className="collapse-head-group col-head">
          <div className="d-flex side-title-collape-btn" onClick={openNav}>
            <p>Projects</p>
            <button>
              <span className="material-icons-round">keyboard_arrow_left</span>
            </button>
          </div>

          {hasPermission(permissions, ["projects:write"]) && (
            <div className="tsk-btn">
              <button
                className="d-flex"
                type="button"
                onClick={() =>
                  openProjectModal(
                    role,
                    user,
                    setIsProjectUpdate,
                    createProject,
                    setInputField
                  )
                }
              >
                <span className="material-icons-round">add</span>
                <p>Create Project</p>
              </button>
            </div>
          )}
        </div>
        <div className="col-body">
          {projectsList?.map((project: any, i: number) => {
            return (
              <ProjectItemContainer
                key={i}
                clientName={project?.clientName}
                projects={project?.projects}
                selectProject={selectProject}
                selectProjectName={selectProjectName}
                projectId={projectId}
                setSelectedSort={setSelectedSort}
                setSelectedStatus={setSelectedStatus}
                setSelectedAssignee={setSelectedAssignee}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

const CountLabel = ({
  count,
  label,
  separator,
}: {
  count: number;
  label: string | undefined;
  separator: boolean;
}) => {
  return (
    <>
      <div className="d-flex">
        <p className="lab-dot"></p>
        <p>{`${count} ${label}`}</p>
      </div>
    </>
  );
};

const ShowMoreList = ({
  moreOptionsList,
  selectOption,
  showList,
  updateSelectOption,
  setShowOption,
  projectShow,
  setIsProjectUpdate,
  setInputField,
  details,
  projectDetailsShow,
}: {
  selectOption: string;
  showList: boolean;
  details: ProjectForm;
  updateSelectOption: React.Dispatch<React.SetStateAction<string>>;
  setShowOption: React.Dispatch<React.SetStateAction<boolean>>;
  projectShow: () => void;
  projectDetailsShow: () => void;
  setIsProjectUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  setInputField: React.Dispatch<React.SetStateAction<ProjectForm>>;
  moreOptionsList: { label: string; value: string }[];
}) => {
  return (
    <Dropdown
      className="d-flex more-opt"
      value={selectOption}
      onChange={(e) => {
        const selectedValue = e.target.value;
        updateSelectOption(selectedValue);
        if (selectedValue === "projects") {
          viewProjectDetails(
            details,
            projectDetailsShow,
            setIsProjectUpdate,
            setShowOption,
            showList,
            updateSelectOption,
            setInputField
          );
        }
      }}
      options={moreOptionsList}
      placeholder=""
    />
  );
};

const viewProjectDetails = (
  details: ProjectForm,
  projectDetailsShow: () => void,
  setIsProjectUpdate: React.Dispatch<React.SetStateAction<boolean>>,
  setShowOption: React.Dispatch<React.SetStateAction<boolean>>,
  showList: boolean,
  updateSelectOption: React.Dispatch<React.SetStateAction<string>>,
  setInputField: React.Dispatch<React.SetStateAction<ProjectForm>>
) => {
  projectDetailsShow();
  setIsProjectUpdate(true);
  setShowOption(!showList);
  setInputField({
    _id: details._id,
    project_name: details.project_name,
    project_tag: details.project_tag,
    client: details.client,
    duration: details.duration?.split(" ")[0],
    duration_type: details.duration?.split(" ")[1],
    due_date: dateBeautify(details.due_date),
    status: details.status,
    project_type: details.project_type,
    description: details.description,
    leader: details.leader,
    manager: details.manager,
    techLeader: details?.techLeader,
    estimate_start_date: details?.estimate_start_date,
    estimate_end_date: details?.estimate_end_date,
    actual_start_date: details?.actual_start_date,
    actual_end_date: details?.actual_end_date,
    estimate_time: details?.estimate_time,
    actual_time: details?.actual_time,
    estimate_time_type: details?.estimate_time_type,
    actual_time_type: details?.actual_time_type,
    sprint_tag: details?.sprint_tag,
    contributors: details.contributors,
    assignees_visibility: details.assignees_visibility,
    contributor: "",
  });
  updateSelectOption("");
};

const ProjectHeader = ({
  role,
  projectName,
  totalTask,
  showList,
  myToast,
  createTask,
  selectOption,
  updateSelectOption,
  setShowOption,
  setIsProjectUpdate,
  projectDetails,
  projectShow,
  setInputField,
  projectDetailsShow,
}: {
  role: any;
  projectName: string | undefined;
  totalTask: TaskTotalType | undefined;
  showList: boolean;
  createTask: () => void;
  selectOption: string;
  updateSelectOption: React.Dispatch<React.SetStateAction<string>>;
  setShowOption: React.Dispatch<React.SetStateAction<boolean>>;
  setIsProjectUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  setInputField: React.Dispatch<React.SetStateAction<ProjectForm>>;
  projectShow: () => void;
  projectDetailsShow: () => void;
  projectDetails: ProjectForm;
  myToast: any;
}) => {
  const moreOptionsList = [
    { label: "Project Details", value: "projects" },
    // { label: 'Export CSV', value: 'csv' }
  ];

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  return (
    <div className="d-flex dtls-top-sec">
      <div className="d-flex task-nm-dtls">
        <div className="d-flex">
          <span className="material-icons-outlined">folder_open</span>
          <p>{projectName}</p>
        </div>
      </div>
      <div className="d-flex task-dp-dtls">
        <div className="d-flex tsk-counts">
          <CountLabel
            count={totalTask ? totalTask.totalTasks : 0}
            label="Tasks"
            separator={false}
          />
          <CountLabel
            count={totalTask ? totalTask.totalSubTasks : 0}
            label="Sub Tasks"
            separator={true}
          />
          <CountLabel
            count={totalTask ? totalTask.totalMembers : 0}
            label="Members"
            separator={true}
          />
        </div>
        <CreateButton
          label="Task"
          handleClick={createTask}
          permission="tasks:write"
        />
        <div className="d-flex activity-btn">
          <button
            className=""
            onClick={() => showToast("warn", "", "Coming soon...")}
          >
            <span className="material-icons-outlined">insights</span>
          </button>

        </div>

        <div className="d-flex more-opt">
          <ShowMoreList
            moreOptionsList={moreOptionsList}
            selectOption={selectOption}
            showList={showList}
            setShowOption={setShowOption}
            details={projectDetails}
            projectShow={projectShow}
            updateSelectOption={updateSelectOption}
            setIsProjectUpdate={setIsProjectUpdate}
            setInputField={setInputField}
            projectDetailsShow={projectDetailsShow}
          />
        </div>
      </div>
    </div>
  );
};

const TaskStatusSelect = ({
  selectStatus,
  updateSelectStatus,
  selectedCountryTemplate,
}: {
  updateSelectStatus: any;
  selectStatus: string[];
  selectedCountryTemplate: any;
}) => {
  const { taskStatus, isLoading, isError } = useTaskStatus();
  let statusList;

  if (taskStatus) {
    statusList = [{ _id: "All", name: "All" }, ...taskStatus];
  }

  return (
    <MultiSelect
      optionLabel="name"
      optionValue="_id"
      value={selectStatus}
      onChange={(e) => updateSelectStatus(e.target.value)}
      options={taskStatus}
      placeholder="Select Status"
      maxSelectedLabels={1}

    />
  );
};



const TaskFilters = ({
  projectId,
  updateSelectStatus,
  updateSelectSort,
  selectSort,
  selectStatus,
  selectAssignee,
  updateSelectAssignee,
  taskList,
  selectSprint,
  updateSelectSprint,
}: {
  projectId: string | undefined;
  updateSelectStatus: React.Dispatch<React.SetStateAction<string[]>>;
  updateSelectSort: React.Dispatch<React.SetStateAction<string>>;
  selectStatus: string[];
  selectSort: string;
  selectAssignee: string[];
  updateSelectAssignee: React.Dispatch<React.SetStateAction<string[]>>;
  taskList: TaskType[] | undefined;
  selectSprint: string | null;
  updateSelectSprint: React.Dispatch<React.SetStateAction<string[] | null>>;
}) => {
  const currentUserRole = localStorage.getItem('currentUserRole');
  const employeeId = localStorage.getItem('employeeId');

  const { assigneesList } = useProjectFilterAssignees(projectId);
  useEffect(() => {
    updateSelectStatus([]);
    updateSelectAssignee([]);
  }, []);


  const { taskLists } = useFullTaskListByProjectId(projectId);

  const priorityData = [
    { label: "Created Date", value: "Default" },
    { label: "End Date (N to O)", value: "DLH" },
    { label: "End Date (O to N)", value: "DHL" },
    { label: "Priority (H to L)", value: "PHL" },
    { label: "Priority (L to H)", value: "PLH" },
  ];


  const sprintTagsOptions = Array.from(
    new Set(
      taskLists?.result
        ?.flatMap((task: any) => task?.sprint_tag || [])
        .filter((tag: any) => tag && tag.trim() !== "")
    )
  ).map((tag) => ({ label: tag, value: tag }));


  const breakData = [
    {
      label: "Both", value: "both"
    },
    {
      label: "Lunch", value: "lunch"
    },
    {
      label: "Tea break", value: "tea_break"
    }
  ]


  useEffect(() => {
    if (currentUserRole?.toLowerCase() === 'contributor' && employeeId) {
      updateSelectAssignee([employeeId]);
    } else {
      updateSelectStatus([]);
      updateSelectAssignee([]);
    }
  }, [projectId, currentUserRole, employeeId]);


  let assignees;
  if (assigneesList) {
    assignees = currentUserRole === 'contributor'
      ? assigneesList.filter((assignee) => assignee._id === employeeId)
      : [
        { _id: "UnAssigned", name: "UnAssigned", profilepic: "" },
        ...assigneesList,
      ];
  }

  const selectedCountryTemplate: React.FC = (option: any, props: any) => {
    if (option) {
      return (
        <>
          <span
            style={{ backgroundColor: option.color }}
            className="material-icons-outlined"
          >
            filter_alt
          </span>
          <span>{option.name}</span>
        </>
      );
    }

    return (
      <>
        <span className="material-icons-outlined">filter_alt</span>
        <span>{props.placeholder}</span>
      </>
    );
  };


  const formatSelectedValues = (values: any) => {
    if (values.length > 3) {
      return `${values.slice(0, 3).join(", ")} +${values.length - 3}`;
    }
    return values.join(", ");
  };



  return (
    <>
      {" "}
      {assigneesList && assigneesList.length ? (
        <div className="d-flex tsk-filter-sec">
          <div className="d-flex filter-lft">
            <div className="d-flex drpdwn-slct status-slct">
              <div className="user-image-block-sm">
                <span className="material-icons-outlined">people</span>
              </div>
              <MultiSelect
                optionLabel="name"
                optionValue="_id"
                value={selectAssignee}
                onChange={(e) => updateSelectAssignee(e.target.value)}
                options={assignees}
                placeholder="Select Assignee"
                // display={(options: any) => formatSelectedValues(options.value)}
                maxSelectedLabels={1}

              />
            </div>
          </div>
          <div className="d-flex filter-ryt">


            {(taskList || []).length > 0 && (
              <div className="d-flex drpdwn-slct status-slct">
                <button
                  className="d-flex"
                  type="button"
                  onClick={() => convertJSONtoCSV(taskList, "TaskFiltersData.csv")}
                >
                  <span className="material-icons-round">download</span>
                  <p>Download</p>
                </button>
              </div>
            )}
            {/* Filter tag  */}
            <div className="d-flex drpdwn-slct status-slct">
              <span className="material-icons-outlined">sell</span>
              <MultiSelect
                optionLabel="label"
                optionValue="value"
                options={sprintTagsOptions}
                onChange={(e) => updateSelectSprint(e.value)}
                value={selectSprint}
                placeholder="Select Tags"
                // display={(options: any) => formatSelectedValues(options.value)}
                maxSelectedLabels={1}

              />

            </div>
            <div className="d-flex drpdwn-slct status-slct">
              <span className="material-icons-outlined">filter_alt</span>
              <TaskStatusSelect
                selectStatus={selectStatus}
                updateSelectStatus={updateSelectStatus}
                selectedCountryTemplate={selectedCountryTemplate}
              />
            </div>
            <div className="d-flex drpdwn-slct">
              <span className="material-icons-round">sort</span>
              <Dropdown
                value={selectSort}
                onChange={(e) => updateSelectSort(e.target.value)}
                options={priorityData}
                placeholder="Select"
              />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

const SubTaskList = ({
  subTasks,
  selectSubTask,
  selectedSubTaskId,
  openSidePanel,
}: {
  subTasks: SubTask[];
  selectSubTask: any;
  selectedSubTaskId: string;
  openSidePanel: any;
}) => {
  const handleClick = (_id: string) => (e: any) => {
    e.stopPropagation();
    selectSubTask(_id);
    openSidePanel();
  };

  return (
    <div className="sub-tasks">
      <div className="line-exp">
        {subTasks.map(({ _id, name, sprint_tag, status, due_date, assignee }) => {
          return (
            <div key={_id} className="d-flex">
              <div
                onClick={handleClick(_id)}
                className={`d-flex mt-five sub-tsk-ml lst-tsk-nm ${selectedSubTaskId === _id ? "clicked" : ""
                  }`}
              >
                <div className="d-flex sub-tsk-wid tsk-box">
                  <div className="d-flex list-nm-ryt">
                    <div className="d-flex sub-tsk-icon">
                      <span className="material-icons-round in-review">
                        subdirectory_arrow_right
                      </span>
                    </div>
                    <div className="d-flex tsk-id">
                      <p>{_id}</p>
                    </div>
                    <div className="d-flex tsk-nm 1">
                      <p>{name}</p>
                    </div>
                  </div>
                </div>
                <div className="d-flex sub-sts-wid sts-wid box">
                  <p className="status-nm">{sprint_tag ? sprint_tag : "NA"}</p>
                </div>
                <div className="d-flex sub-assig-wid assig-wid assig-box">
                  {assignee.profilepic ? (
                    <div className="d-flex assig-pic" title={assignee?.name}>
                      <DefaultImage
                        src={assignee.profilepic}
                        alt=""
                        className={""}
                        letter={assignee?.name[0]}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {assignee?.name || ""}
                </div>
                
                <div className="d-flex sub-sts-wid sts-wid box">
                  <img src={taskStatusIcons[status.name]} alt="" />
                  <p className="status-nm">{status.name}</p>
                </div>
                {due_date == "" ? (
                  "NA"
                ) : (
                  <div className="d-flex sub-dd-wid dd-wid box">
                    <p className="dd">{dateBeautify(due_date)}</p>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const TaskAssignees = ({ assignees }: { assignees: AssigneeType[] }) => {
  return (
    <div className="d-flex assig-pic assig-wid assig-box">
      {assignees?.map((assignee: any) => {
        return (
          <div key={assignee?._id} className="d-flex assig-pic">
            {/* <img src={assignee.profilepic} alt="" title ={assignee.name} /> */}
            <DefaultImage
              src={assignee?.profilepic}
              alt=""
              className=""
              // letter={assignee?.name ? assignee?.name[0] : ""}
              letter={assignee?.name[0]}
            />
          </div>
        );
      })}
    </div>
  );
};

const TaskItem = ({
  task,
  openSidePanel,
  selectTask,
  selectedTaskId,
  setActiveIndex,
}: {
  task: any;
  openSidePanel: (task: TaskType) => void;
  selectTask: any;
  selectedTaskId: string;
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const {
    taskId,
    name,
    estimation_time,
    actual_time,
    sprint_tag,
    members,
    status: taskStatus,
    due_date,
    priority,
    subTasks,
    _id,
  } = task;
  const handleClick = () => {
    openSidePanel(task);
    selectTask(_id);
  };

  const handleOpenSidePanel = () => {
    openSidePanel(task);
    setActiveIndex(1);
  };

  return (
    <div className={`lst-tsk-main`} onClick={handleClick}>
      <div
        className={`d-flex lst-tsk-nm ${_id === selectedTaskId ? "clicked" : ""
          }`}
      >
        <div className="d-flex tsk-wid tsk-box">
          <div className="d-flex list-nm-ryt">
            <div className="d-flex tsk-icon">
              <span className="material-icons-round">bolt</span>
            </div>
            <div className="d-flex tsk-id">
              <p>{taskId}</p>
            </div>
            <div className="d-flex tsk-nm 2">
              <p>        <span className="tsk-nm-span">{name}</span> <span className="tsk-nm-spnt-hrs">&nbsp; ({actual_time !== undefined && actual_time !== null ? actual_time : "0"}/{estimation_time || "0"}) hr </span>
              </p>
            </div>
          </div>
          {/* <div className="d-flex tsk-exp-more">
                        <span className="material-icons-round">expand_less</span>
                    </div> */}
        </div>
        <div className="d-flex sts-wid box">
          <p className="status-nm">{sprint_tag ? sprint_tag : "NA"}</p>
        </div>
        <TaskAssignees assignees={members} />
        <div className="d-flex sts-wid box">
          <img src={taskStatusIcons[taskStatus]} alt="" />
          <p className="status-nm">{taskStatus}</p>
        </div>
        <div className="d-flex dd-wid box">
          <p className="dd">{dateBeautify(due_date)}</p>
        </div>
        <div className="d-flex prio-wid prio-box high">
          <span className="material-icons-round"></span>
          <p className="prio-nm">{priority}</p>
        </div>
      </div>
      <SubTaskList
        subTasks={subTasks}
        selectSubTask={selectTask}
        selectedSubTaskId={selectedTaskId}
        openSidePanel={handleOpenSidePanel}
      />
    </div>
  );
};

const TaskList = ({
  taskList,
  openSidePanel,
  setActiveIndex,
}: {
  taskList: TaskType[] | undefined;
  openSidePanel: (task: TaskType) => void;
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const [selectedTask, setSelectedTask] = useState("");

  return (
    <div className="dtls-mn-sec">
      <div className="d-flex list-headings">
        <p className="d-flex tsk-wid">task</p>
        <p className="d-flex assig-wid">tag</p>
        <p className="d-flex assig-wid">assignees</p>
        <p className="d-flex sts-wid">status</p>
        <p className="d-flex dd-wid">due date</p>
        <p className="d-flex prj-wid">priority</p>
      </div>
      {taskList?.map((task: TaskType) => (
        <TaskItem
          key={task._id}
          task={task}
          openSidePanel={openSidePanel}
          selectTask={setSelectedTask}
          selectedTaskId={selectedTask}
          setActiveIndex={setActiveIndex}
        />
      ))}
    </div>
  );
};

const SelectWithSideLabel = ({
  options,
  value,
  setValue,
}: {
  options: { label: string; value: string }[];
  value: string;
  setValue: (value: string) => void;
}) => {
  return (
    <div className="d-flex list-headings">
      <p className="d-flex">status</p>
      <div className="drpdwn-slct">
        <Dropdown
          value={value}
          onChange={(e) => setValue(e.target.value)}
          options={options}
        />
      </div>
    </div>
  );
};

// const SelectAssignees = ({
//   assigneesList,
//   assignees,
//   name,
// }: {
//   assigneesList: AssigneeType[] | undefined;
//   assignees: AssigneeType[];
//   name: string;
// }) => {
//   const formProps = { name };
//   const {
//     touched,
//     setFieldValue,
//     values: { member, members },
//   } = useFormikContext<TaskForm>();

//   const checkForAssinged = (id: string) => {
//     let data = new Set(
//       assignees?.map((e) => {
//         return e?._id;
//       })
//     );
//     if (data.has(id)) return false;
//     return true;
//   };
//   const [field, meta] = useField(formProps);
//   const [assignedFilterData, setAssignedFilterData] = useState(
//     assigneesList?.filter(
//       (assignees) =>
//         assignees?._id !== member && checkForAssinged(assignees?._id)
//     ) || []
//   );
//   const getAssigneeFromList = () =>
//     assigneesList
//       ?.filter((person) => person._id === member)
//       .reduce(
//         (preValue, currValue) => {
//           const { name, profilepic, _id } = currValue;
//           preValue.name = name;
//           preValue.profilepic = profilepic || "";
//           preValue._id = _id;
//           return preValue;
//         },
//         { name: "", profilepic: "", _id: "" }
//       );

//   const removeMatchedAssignees = (
//     assigneesList: AssigneeType[],
//     person: AssigneeType
//   ) => {
//     assigneesList.forEach((res, index) => {
//       if (res._id == person._id) {
//         assigneesList.splice(index, 1); // remove element
//       }
//     });
//     return assigneesList;
//   };
//   useEffect(() => {
//     if (member) {
//       const person = getAssigneeFromList();
//       // if (assigneesList && person) {
//       //     removeMatchedAssignees(assigneesList, person)
//       // }
//       setFieldValue("members", [...members, person && person]);
//     }
//   }, [member]);
//   useEffect(() => {
//     setAssignedFilterData(
//       assigneesList?.filter(
//         (assignees) =>
//           assignees?._id !== member && checkForAssinged(assignees?._id)
//       ) || []
//     );
//   }, [assignees]);

//   const assgineesOptionTemplate = (option: any) => {
//     return (
//       <div className="d-flex sm-user-name" key={option.name}>
//         {/* <img style={{ width: 15 }} src={option.profilepic} /> */}
//         <DefaultImage
//           src={option.profilepic}
//           alt=""
//           className=""
//           letter={option.name[0]}
//           style={{ width: 15 }}
//         />
//         <div>{option.name}</div>
//       </div>
//     );
//   };

//   return (
//     <>
//       <div className="d-flex add-assignee-ui-group list-headings">
//         <p className="d-flex add-assignee-title-count">ASSIGNEES</p>
//         <div className="d-flex add-assig list-headings">
//           <button>
//             <span className="material-icons-round">add</span>
//           </button>
//           <Dropdown
//             name="member"
//             optionLabel="name"
//             optionValue="_id"
//             value={field.value}
//             onChange={field.onChange}
//             options={assignedFilterData}
//             itemTemplate={assgineesOptionTemplate}
//             // valueTemplate={selectedAssgineesTemplate}
//             className="p-dropaassignees"
//           />
//         </div>
//       </div>
//       <div className="lst-tsk-nm">
//         {assignees?.map((assignee, index) =>
//           assignee.name !== " " && assignee._id !== "" ? (
//             <div className="d-flex assig-mem" key={index}>
//               <div className="d-flex">
//                 {/* <img src={assignee.profilepic} alt="" /> */}
//                 <DefaultImage
//                   src={assignee.profilepic}
//                   alt=""
//                   className=""
//                   letter={assignee.name[0]}
//                 />
//                 <p>{assignee.name}</p>
//               </div>
//               <div
//                 className="d-flex"
//                 onClick={() => {
//                   setFieldValue(
//                     "members",
//                     assignees?.filter((person) => person._id !== assignee._id)
//                   );
//                 }}
//               >
//                 <span className="material-icons-round">close</span>
//               </div>
//             </div>
//           ) : (
//             ""
//           )
//         )}
//       </div>
//     </>
//   );
// };

const SelectAssignees = ({
  assigneesList,
  assignees,
  name,
}: {
  assigneesList: AssigneeType[] | undefined;
  assignees: AssigneeType[];
  name: string;
}) => {
  const formProps = { name };
  const {
    touched,
    setFieldValue,
    values: { member, members },
  } = useFormikContext<TaskForm>();
  const [field, meta] = useField(formProps);

  // Check if an assignee is already assigned
  const checkForAssigned = (id: string) => {
    return assignees?.some((e) => e?._id === id) ? false : true;
  };

  // Function to get an assignee from the list based on member ID
  const getAssigneeFromList = () => {
    const assignee = assigneesList?.find((person) => person?._id === member);
    if (assignee) {
      const { name, profilepic, _id } = assignee;
      return { name, profilepic: profilepic || "", _id };
    }
    return null;
  };

  // Filter assigned assignees and update state
  const [assignedFilterData, setAssignedFilterData] = useState<AssigneeType[]>(
    []
  );

  useEffect(() => {
    const filteredData =
      assigneesList?.filter(
        (assignee) =>
          assignee?._id !== member && checkForAssigned(assignee?._id)
      ) || [];
    setAssignedFilterData(filteredData);
  }, [assignees, member, assigneesList]);

  // it work correctly but first person cannot able to remove
  // useEffect(() => {
  //   if (member) {
  //     const person = getAssigneeFromList();
  //     if (person) {
  //       // Ensure the new person is added to the 'members' list without duplicating existing values
  //       const updatedMembers = [...members];
  //       if (!updatedMembers.some((m) => m?._id === person?._id)) {
  //         setFieldValue("members", [...updatedMembers, person]);
  //       }
  //     }
  //   }
  // }, [member, setFieldValue, members]);

  useEffect(() => {
    if (member) {
      const person = getAssigneeFromList();
      if (person && !members.some((m) => m._id === person._id)) {
        // Add the new member immediately
        const updatedMembers = [...members, person];
        setFieldValue("members", updatedMembers);
        setFieldValue("member", ""); // Reset the member field after addition
      }
    }
  }, [member, setFieldValue, members]);

  // Template for displaying each assignee in the dropdown
  const assigneesOptionTemplate = (option: AssigneeType) => {
    return (
      <div className="d-flex sm-user-name" key={option?._id}>
        <DefaultImage
          src={option?.profilepic}
          alt=""
          letter={option?.name[0]}
          style={{ width: 15 }}
        />
        <div>{option?.name}</div>
      </div>
    );
  };

  // Handle removing an assignee and updating the available list
  const handleRemoveAssignee = (assigneeId: string) => {
    const updatedAssignees = assignees?.filter(
      (person) => person?._id !== assigneeId
    );
    setFieldValue("members", updatedAssignees);
  };

  return (
    <>
      <div className="d-flex add-assignee-ui-group list-headings">
        <p className="d-flex add-assignee-title-count">ASSIGNEES</p>
        <div className="d-flex add-assig list-headings">
          <button>
            <span className="material-icons-round">add</span>
          </button>
          <Dropdown
            name="member"
            optionLabel="name"
            optionValue="_id"
            value={field.value}
            onChange={field.onChange}
            options={assignedFilterData}
            itemTemplate={assigneesOptionTemplate}
            className="p-dropaassignees"
          />
        </div>
      </div>
      <div className="lst-tsk-nm">
        {members?.map((assignee, index) => (
          <div className="d-flex assig-mem" key={assignee._id}>
            <div className="d-flex">
              <DefaultImage
                src={assignee.profilepic}
                alt=""
                letter={assignee.name[0]}
              />
              <p>{assignee.name}</p>
            </div>
            <div
              className="d-flex"
              onClick={() => handleRemoveAssignee(assignee._id)}
            >
              <span className="material-icons-round">close</span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

const SelectContributors = ({
  assigneesList,
  assignees,
  name,
  leader,
  manager,
  isProjectUpdate,
}: {
  isProjectUpdate: boolean;
  assigneesList: AssigneeType[] | undefined;
  assignees: AssigneeType[];
  name: string;
  leader: string;
  manager: string;
}) => {
  const formProps = { name };
  const {
    touched,
    setFieldValue,
    values: { contributor, contributors },
  } = useFormikContext<ProjectForm>();

  const [field, meta] = useField(formProps);

  const getAssigneeFromList = (person: any) =>
    assigneesList
      ?.filter((item) => item._id === person)
      .reduce(
        (preValue, currValue) => {
          const { name, profilepic, _id } = currValue;
          preValue.name = name;
          preValue.profilepic = profilepic || "";
          preValue._id = _id;
          return preValue;
        },
        { name: "", profilepic: "", _id: "" }
      );

  const removeMatchedAssignees = (
    assigneesList: AssigneeType[],
    person: AssigneeType
  ) => {
    assigneesList.forEach((res, index) => {
      if (res._id == person._id) {
        assigneesList.splice(index, 1); // remove element
      }
    });
    return assigneesList;
  };

  useEffect(() => {
    if (contributor) {
      const person = getAssigneeFromList(contributor);
      if (assigneesList && person && person._id != "") {
        // removeMatchedAssignees(assigneesList, person);
        setFieldValue("contributors", [...contributors, person]);
      }
    }
  }, [contributor]);

  useEffect(() => {
    if (leader) {
      setAssignees(leader);
    }
  }, [leader]);

  useEffect(() => {
    if (manager) {
      setAssignees(manager);
    }
  }, [manager]);

  const setAssignees = (selectedPerson: any) => {
    const person = getAssigneeFromList(selectedPerson);
    if (person && person._id) {
      if (isProjectUpdate) {
        let list = [...contributors, person].filter((obj, pos, arr) => {
          return arr.map((mapObj) => mapObj?._id).indexOf(obj?._id) === pos;
        });
        setFieldValue("contributors", list);
      } else {
        setFieldValue("contributors", [...contributors, person]);
      }
    }
  };

  const assgineesOptionTemplate = (option: any) => {
    return (
      <div className="d-flex sm-user-name">
        {/* <img style={{ width: 15 }} src={option.profilepic} /> */}
        <DefaultImage
          src={option.profilepic}
          alt=""
          className=""
          letter={option.name[0]}
          style={{ width: 15 }}
        />
        <div>{option.name}</div>
      </div>
    );
  };

  const tempAssignees = assigneesList?.filter(
    (assignee) => assignee?._id !== leader && assignee?._id !== manager
  );

  return (
    <>
      <div className="d-flex add-assig list-headings">
        <button>
          <span className="material-icons-round">add</span>
        </button>
        <Dropdown
          name="contributor"
          optionLabel="name"
          optionValue="_id"
          value={field.value}
          onChange={field.onChange}
          options={assigneesList}
          itemTemplate={assgineesOptionTemplate}
          // valueTemplate={selectedAssgineesTemplate}
          className="p-dropaassignees"
        />
      </div>

      <div className="lst-tsk-nm">
        {assignees?.map((assignee, index) =>
          assignee.name !== " " && assignee._id !== "" ? (
            <div className="d-flex assig-mem" key={index}>
              <div className="d-flex">
                {/* <img src={assignee.profilepic} alt="" /> */}
                <DefaultImage
                  src={assignee.profilepic}
                  alt=""
                  className=""
                  letter={assignee.name[0]}
                />
                <p>{assignee.name}</p>
              </div>
              <div
                className="d-flex"
                onClick={() => {
                  setFieldValue(
                    "contributors",
                    assignees?.filter((person) => person._id !== assignee._id)
                  );
                }}
              >
                <span className="material-icons-round">close</span>
              </div>
            </div>
          ) : (
            ""
          )
        )}
      </div>
    </>
  );
};

const SelectContributorsView = ({
  assigneesList,
  assignees,
  name,
  leader,
  manager,
  isProjectUpdate,
}: {
  isProjectUpdate: boolean;
  assigneesList: AssigneeType[] | undefined;
  assignees: AssigneeType[];
  name: string;
  leader: string;
  manager: string;
}) => {
  const formProps = { name };
  const {
    touched,
    setFieldValue,
    values: { contributor, contributors },
  } = useFormikContext<ProjectForm>();

  const [field, meta] = useField(formProps);
  const getAssigneeFromList = (person: any) =>
    assigneesList
      ?.filter((item) => item._id === person)
      .reduce(
        (preValue, currValue) => {
          const { name, profilepic, _id } = currValue;
          preValue.name = name;
          preValue.profilepic = profilepic || "";
          preValue._id = _id;
          return preValue;
        },
        { name: "", profilepic: "", _id: "" }
      );

  const removeMatchedAssignees = (
    assigneesList: AssigneeType[],
    person: AssigneeType
  ) => {
    assigneesList.forEach((res, index) => {
      if (res._id == person._id) {
        assigneesList.splice(index, 1); // remove element
      }
    });
    return assigneesList;
  };

  useEffect(() => {
    if (contributor) {
      const person = getAssigneeFromList(contributor);
      if (assigneesList && person) {
        removeMatchedAssignees(assigneesList, person);
      }
      setFieldValue("contributors", [...contributors, person && person]);
    }
  }, [contributor]);

  useEffect(() => {
    if (leader) {
      setAssignees(leader);
    }
  }, [leader]);

  useEffect(() => {
    if (manager) {
      setAssignees(manager);
    }
  }, [manager]);

  const setAssignees = (selectedPerson: any) => {
    const person = getAssigneeFromList(selectedPerson);
    if (isProjectUpdate) {
      let list = [...contributors, person].filter((obj, pos, arr) => {
        return arr.map((mapObj) => mapObj?._id).indexOf(obj?._id) === pos;
      });
      setFieldValue("contributors", list);
    } else {
      setFieldValue("contributors", [...contributors, person]);
    }
  };

  const assgineesOptionTemplate = (option: any) => {
    return (
      <div className="d-flex sm-user-name">
        {/* <img style={{ width: 15 }} src={option.profilepic} /> */}
        <DefaultImage
          src={option.profilepic}
          alt=""
          className=""
          letter={option.name[0]}
          style={{ width: 15 }}
        />
        <div>{option.name}</div>
      </div>
    );
  };

  const tempAssignees = assigneesList?.filter(
    (assignee) => assignee._id !== leader && assignee._id !== manager
  );

  return (
    <>
      <div className="lst-tsk-nm">
        {assignees?.map((assignee, index) =>
          assignee.name !== " " && assignee._id !== "" ? (
            <div className="d-flex assig-mem" key={index}>
              <div className="d-flex">
                {/* <img src={assignee.profilepic} alt="" /> */}
                <DefaultImage
                  src={assignee.profilepic}
                  alt=""
                  className=""
                  letter={assignee.name[0]}
                />
                <p>{assignee.name}</p>
              </div>
              {/* <div className="d-flex" onClick={() => { setFieldValue("contributors", assignees?.filter(person => person._id !== assignee._id)) }}>
                                <span className="material-icons-round">close</span>
                            </div> */}
            </div>
          ) : (
            ""
          )
        )}
      </div>
    </>
  );
};

const CreateTaskModal = ({
  myToast,
  show,
  handleClose,
  projectId,
  selectedAssignee,
  selectedStatus,
  selectedSort,
  selectedSprint,
  refreshTaskList,
  role,
}: {
  myToast: any;
  show: boolean;
  handleClose: () => void;
  projectId: string | undefined;
  selectedAssignee: string;
  selectedStatus: string;
  selectedSort: string;
  selectedSprint: string;
  refreshTaskList: any;
  role: any;
}) => {
  const [isAddButtonClicked, setIsAddButtonClicked] = useState(false);
  const [hasShownWarning, setHasShownWarning] = useState(false);

  const taskForm: TaskForm = {
    _id: "",
    name: "",
    // status: "6202607586eb533fede8c296",
    status: "620260ab86eb533fede8c29f",
    priority: "Low",
    estimation_time: 0,
    estimation_time_type: "",
    actual_time: 0,
    actual_time_type: "",
    log_time: 0,
    start_date: "",
    due_date: "",
    actual_start_date: "",
    actual_due_date: "",
    reference_taskId: "",
    description: "",
    projectId: projectId || "",
    members: [],
    subTasks: [],
    documents: [],
    member: "",
    sprint_tag: "",
  };

  const { taskStatus } = useTaskStatus();

  let statusFilter: any[];

  if (taskStatus) {
    statusFilter = taskStatus?.filter((item) => item.name !== "All");
  }
  const { taskList } = useTaskList(
    projectId,
    selectedAssignee,
    selectedStatus,
    selectedSort,
    selectedSprint,
  );

  const { projectAssignees } = useProjectAssignees(projectId);

  const nameValidation = Yup.string()
    .matches(
      /^[\w\W]+$/,

      "Only alphanumeric characters and #$:_@- are allowed."
    ) // Allow alphanumeric and selected special characters
    .test(
      "is-valid-combination",
      "Name cannot contain only numbers or only special characters.",
      function (value) {
        if (!value) return false; // Handle empty strings or undefined values
        const hasLetters = /[A-Za-z]/.test(value); // Check if there are letters
        const hasNumbersOrSpecialChars = /[0-9#$:_@-]/.test(value); // Check if there are numbers or special characters

        // Valid if it contains at least one letter, along with optional numbers or special characters
        return (hasLetters && hasNumbersOrSpecialChars) || hasLetters;
      }
    )
    .required("*"); // Required field validation

  const taskFormValidation = Yup.object({
    name: nameValidation,
    status: Yup.string().required("*"),
    priority: Yup.string().required("*"),
    estimation_time: Yup.string(),
    estimation_time_type: Yup.string(),
    actual_time: Yup.string(),
    actual_time_type: Yup.string(),
    log_time: Yup.number(),
    start_date: Yup.string().required("*"),
    due_date: Yup.string()
      .required("*")
      .test("is-greater-than-start-date", "End date must be greater than start date", function (value) {
        const { start_date } = this.parent;
        if (start_date && value) {
          return new Date(value) >= new Date(start_date);
        }
        return true;
      }),
    actual_start_date: Yup.string(),
    actual_due_date: Yup.string()
      .test("is-greater-than-start-date", "End date must be greater than actual start date", function (value) {
        const { actual_start_date } = this.parent;
        if (actual_start_date && value) {
          return new Date(value) >= new Date(actual_start_date);
        }
        return true;
      }),
    reference_taskId: Yup.string(),
    description: Yup.string().required("*"),
    projectId: Yup.string().required("*"),
    members: Yup.array()
      .of(
        Yup.object().shape({
          _id: Yup.string().required("*"),
          profilepic: Yup.string(),
          name: Yup.string().required("*"),
        })
      )
      .min(1, "At least one member is required."),
    subTasks: Yup.array(),
    documents: Yup.array(),
    sprint_tag: Yup.string()
      .matches(/^[A-Za-z0-9 ]+$/, "Only letters, numbers, and spaces are allowed")
      .trim()
      .max(30, "Tag cannot exceed 30 characters")
  });

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const handleTaskForm = async (values: TaskForm) => {
    if (values?.members && values?.members.length > 0) {
      values?.members?.map((items) => {
        const found = items?.profilepic?.match(/\/(userprofile(.*))\?/i);
        if (found) {
          items.profilepic = found[1];
        }
        return items;
      });
    } else {
      values.members = [];
    }
    const {
      name,
      status,
      priority,
      estimation_time,
      actual_time,
      log_time,
      start_date,
      due_date,
      actual_due_date,
      actual_start_date,
      reference_taskId,
      description,
      projectId,
      members,
      subTasks,
      documents,
      member,
      sprint_tag,
    } = values;

    // Adjust the startDate to UTC before conversion
    const startDate = new Date(start_date);
    const utcDate = new Date(
      startDate.getTime() - startDate.getTimezoneOffset() * 60000
    );
    const formattedStartDate = utcDate.toISOString(); // Get the ISO format

    // Adjust the dueDate to UTC before conversion
    const dueDate = new Date(due_date);
    const utcDueDate = new Date(
      dueDate.getTime() - dueDate.getTimezoneOffset() * 60000
    );
    const formattedDueDate = utcDueDate.toISOString(); // Get the ISO format


    // // Adjust the actaulstartDate to UTC before conversion
    //   const actaulstartDate = new Date(actual_start_date);
    //   const utcActualStartDate = new Date(
    //     actaulstartDate.getTime() - actaulstartDate.getTimezoneOffset() * 60000
    //   );
    //   const formattedActualStartDate = utcActualStartDate.toISOString(); // Get the ISO format

    //   // // Adjust the dueDate to UTC before conversion
    //   const actualDueDate = new Date(actual_due_date);
    //   const utcActualDueDate = new Date(
    //     actualDueDate.getTime() - actualDueDate.getTimezoneOffset() * 60000
    //   );
    //  const formattedActualDueDate = utcActualDueDate.toISOString(); // Get the ISO format

    // Ensure actual_start_date is defined before creating a Date object
    const actualStartDate = actual_start_date ? new Date(actual_start_date) : null;
    const formattedActualStartDate = actualStartDate
      ? new Date(actualStartDate.getTime() - actualStartDate.getTimezoneOffset() * 60000).toISOString()
      : null;

    // Ensure actual_due_date is defined before creating a Date object
    const actualDueDate = actual_due_date ? new Date(actual_due_date) : null;
    const formattedActualDueDate = actualDueDate
      ? new Date(actualDueDate.getTime() - actualDueDate.getTimezoneOffset() * 60000).toISOString()
      : null;

    try {
      const resp = await createTask({
        name,
        status,
        priority,
        estimation_time,
        actual_time,
        start_date: formattedStartDate,
        due_date: formattedDueDate,
        actual_due_date: formattedActualDueDate,
        actual_start_date: formattedActualStartDate,
        reference_taskId,
        description,
        projectId,
        members,
        subTasks,
        documents,
        sprint_tag,
        member,
        log_time: 0,
      });
      if (resp.statusCode === 201) {
        showToast(
          "success",
          "Success Message",
          "Task was created successfully."
        );
      }
      refreshTaskList();
    } catch (error) {
      console.log(error);
    }
    handleClose();
    setIsAddButtonClicked(false);
  };

  const selectedStatusTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="d-flex sm-user-name">
          <img style={{ width: 15 }} src={taskStatusIcons[option?.name]} />
          <div>{option?.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const selectedPriorityTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="d-flex sm-user-name">
          <img style={{ width: 15 }} src={priorityIcons[option.value]} />
          <div>{option.value}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const StatusOptionTemplate = (option: any) => {
    return (
      <div className="d-flex sm-user-name">
        <img style={{ width: 15 }} src={taskStatusIcons[option.name]} />
        <div>{option.name}</div>
      </div>
    );
  };

  const PriorityOptionTemplate = (option: any) => {
    return (
      <div className="d-flex sm-user-name">
        <img style={{ width: 15 }} src={priorityIcons[option.value]} />
        <div>{option.value}</div>
      </div>
    );
  };
  const typeOfDuration = [{ _id: "hours", value: "Hours" }];

  useEffect(() => {
    if (hasShownWarning) {
      showToast("warn", "Warning", "Kindly fill the required fields!");
    }
  }, [hasShownWarning]);

  return (
    <Dialog
      className="details-edit-body dtls-update"
      visible={show}
      onHide={handleClose}
      style={{ width: "50vw" }}
      header="Create a Task"
    >
      <Formik
        initialValues={taskForm}
        validationSchema={taskFormValidation}
        onSubmit={async (values, { setSubmitting }) => {
          setIsAddButtonClicked(true);
          await handleTaskForm(values);
          setSubmitting(false);
        }}
      >
        {({ errors, values, touched, isSubmitting, setFieldValue }) => {
          // Show warning when there are errors and the form is being submitted
          if (Object.keys(errors).length > 0 && isSubmitting) {
            setHasShownWarning(true);
          } else {
            setHasShownWarning(false);
          }

          return (
            <Form>
              <div className="modal-body-inner create-task-popup">
                <div className="form-group lg-input">
                  {errors.name && touched.name ? (
                    <span style={{ color: "red" }}>*</span>
                  ) : null}
                  <Field type="text" name="name" placeholder="Task Name *" />
                </div>
                <div className="lst-tsk-nm">
                  <div className="d-flex list-headings">
                    <p className="d-flex">
                      status{" "}
                      {errors.status && touched.status ? (
                        <span style={{ color: "red" }}>*</span>
                      ) : null}
                    </p>
                    <div className="drpdwn-slct">
                      <Field name="status">
                        {({ field }: { field: any }) => (
                          <Dropdown
                            name="status"
                            value={field.value}
                            onChange={field.onChange}
                            options={statusFilter}
                            placeholder="select"
                            optionLabel="name"
                            optionValue="_id"
                            itemTemplate={StatusOptionTemplate}
                            valueTemplate={selectedStatusTemplate}
                          />
                        )}
                      </Field>
                    </div>
                  </div>

                  <div className="d-flex list-headings">
                    <p className="d-flex">
                      priority
                      {errors.priority && touched.priority ? (
                        <span style={{ color: "red" }}>*</span>
                      ) : null}
                    </p>
                    <div className="drpdwn-slct">
                      <Field name="priority">
                        {({ field }: { field: any }) => (
                          <Dropdown
                            name="priority"
                            value={field.value}
                            onChange={field.onChange}
                            options={[
                              { label: "High", value: "High" },
                              { label: "Medium", value: "Medium" },
                              { label: "Low", value: "Low" },
                            ]}
                            placeholder="select"
                            itemTemplate={PriorityOptionTemplate}
                            valueTemplate={selectedPriorityTemplate}
                          />
                        )}
                      </Field>
                    </div>
                  </div>

                  <div className="d-flex list-headings">
                    <p className="d-flex">Estimated Time (Hrs)</p>
                    <div className="drpdwn-slct">
                      <Field
                        name="estimation_time"
                        type="text"
                        onKeyPress={(
                          event: React.KeyboardEvent<HTMLInputElement>
                        ) => {
                          const key = String.fromCharCode(event.which);
                          const input = event.currentTarget.value + key;

                          // Regular expression to allow numbers with up to 2 decimal places
                          const regex = /^\d*\.?\d{0,2}$/;

                          // Check if the resulting value matches the regex
                          if (!regex.test(input)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="d-flex list-headings">
                    <p className="d-flex">Actual Time (Hrs)</p>
                    <div className="drpdwn-slct">
                      <Field
                        name="actual_time"
                        type="text"
                        onKeyPress={(
                          event: React.KeyboardEvent<HTMLInputElement>
                        ) => {
                          const key = String.fromCharCode(event.which);
                          const input = event.currentTarget.value + key;

                          // Regular expression to allow numbers with up to 2 decimal places
                          const regex = /^\d*\.?\d{0,2}$/;

                          // Check if the resulting value matches the regex
                          if (!regex.test(input)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="d-flex list-headings">
                    <p className="d-flex">
                      ESTIMATED START DATE
                      {errors.start_date && touched.start_date ? (
                        <span style={{ color: "red" }}>*</span>
                      ) : null}
                    </p>
                    <div className="drpdwn-slct">
                      <Field name="start_date">
                        {({ field }: { field: any }) => (
                          <Calendar
                            name="start_date"
                            value={field.value}
                            onChange={field.onChange}
                            showIcon
                            icon={"pi pi-calendar"}
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                  <div className="d-flex list-headings">
                    <p className="d-flex">
                      ESTIMATED END DATE
                      {errors.due_date && touched.due_date ? (
                        <span style={{ color: "red" }}>*</span>
                      ) : null}
                    </p>
                    <div className="drpdwn-slct">
                      <Field name="due_date">
                        {({ field }: { field: any }) => (
                          <Calendar
                            name="due_date"
                            value={field.value}
                            onChange={field.onChange}
                            showIcon
                            icon={"pi pi-calendar"}
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                  <div className="d-flex list-headings">
                    <p className="d-flex">
                      ACTUAL START DATE
                      {errors.actual_start_date && touched.actual_start_date ? (
                        <span style={{ color: "red" }}>*</span>
                      ) : null}
                    </p>
                    <div className="drpdwn-slct">
                      <Field name="actual_start_date">
                        {({ field }: { field: any }) => (
                          <Calendar
                            name="actual_start_date"
                            value={field.value}
                            onChange={field.onChange}
                            showIcon
                            icon={"pi pi-calendar"}
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                  <div className="d-flex list-headings">
                    <p className="d-flex">
                      ACTUAL END DATE
                      {errors.actual_due_date && touched.actual_due_date ? (
                        <span style={{ color: "red" }}>*</span>
                      ) : null}
                    </p>
                    <div className="drpdwn-slct">
                      <Field name="actual_due_date">
                        {({ field }: { field: any }) => (
                          <Calendar
                            name="actual_due_date"
                            value={field.value}
                            onChange={field.onChange}
                            showIcon
                            icon={"pi pi-calendar"}
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                  <div className="d-flex list-headings">
                    <p className="d-flex">
                      Tags
                      {errors.sprint_tag && touched.sprint_tag ? (
                        <span style={{ color: "red" }}>*</span>
                      ) : null}
                    </p>
                    <div className="drpdwn-slct">
                      <Field name="sprint_tag">
                        {({ field }: { field: any }) => (
                          <input
                            {...field}
                            name="sprint_tag"
                            id="sprint_tag"
                            type="text"
                            placeholder="Enter Tag Name"
                            value={values.sprint_tag}
                            onChange={field.onChange}
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                  <div className="d-flex list-headings">
                    <p className="d-flex">Reference Task</p>
                    <div className="d-flex drpdwn-slct">
                      <span className="in-pro material-icons-round">bolt</span>
                      <Field name="reference_taskId">
                        {({ field }: { field: any }) => (
                          <select {...field}>
                            <option value="">Select</option>
                            {taskList?.map((task, index) => (
                              <option key={index} value={task._id}>
                                {task.taskId} {task.name}
                              </option>
                            ))}
                          </select>
                        )}
                      </Field>
                    </div>
                  </div>

                </div>
                <div className="d-flex dtls-update">
                  <div className="list-headings description">
                    <p className="d-flex">Comments  {errors?.description && touched?.description ? (
                      <span style={{ color: "red" }}>*</span>
                    ) : null}</p>

                    <Editor
                      className="lst-tsk-nm"
                      id="description"
                      value={values.description}
                      onTextChange={(e) => {
                        setFieldValue("description", e.htmlValue);
                      }}
                      headerTemplate={header}
                    />
                  </div>
                  <div className="assignees">
                    <div className="assignees-item">
                      {errors?.members && touched?.members ? (
                        <span style={{ color: "red" }}>*</span>
                      ) : null}
                      <SelectAssignees
                        assigneesList={projectAssignees}
                        assignees={values?.members}
                        name="member"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className=" modal-footer">
                <div></div>
                <div className=" d-flex">
                  <button
                    type="button"
                    className="btn cancel"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn save"
                    disabled={isAddButtonClicked}
                  >
                    Add
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

const header = (
  <>
    <span className="ql-formats">
      <button className="ql-bold" aria-label="Bold"></button>
      <button className="ql-italic" aria-label="Italic"></button>
      <button className="ql-underline" aria-label="Underline"></button>
      <button
        type="button"
        className="ql-list"
        value="ordered"
        aria-label="Ordered List"
      >
        <svg viewBox="0 0 18 18">
          {" "}
          <line className="ql-stroke" x1="7" x2="15" y1="4" y2="4"></line>{" "}
          <line className="ql-stroke" x1="7" x2="15" y1="9" y2="9"></line>{" "}
          <line className="ql-stroke" x1="7" x2="15" y1="14" y2="14"></line>{" "}
          <line
            className="ql-stroke ql-thin"
            x1="2.5"
            x2="4.5"
            y1="5.5"
            y2="5.5"
          ></line>{" "}
          <path
            className="ql-fill"
            d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"
          ></path>{" "}
          <path
            className="ql-stroke ql-thin"
            d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"
          ></path>{" "}
          <path
            className="ql-stroke ql-thin"
            d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"
          ></path>{" "}
        </svg>
      </button>
      <button
        type="button"
        className="ql-list"
        value="bullet"
        aria-label="Unordered List"
      >
        <svg viewBox="0 0 18 18">
          {" "}
          <line className="ql-stroke" x1="6" x2="15" y1="4" y2="4"></line>{" "}
          <line className="ql-stroke" x1="6" x2="15" y1="9" y2="9"></line>{" "}
          <line className="ql-stroke" x1="6" x2="15" y1="14" y2="14"></line>{" "}
          <line className="ql-stroke" x1="3" x2="3" y1="4" y2="4"></line>{" "}
          <line className="ql-stroke" x1="3" x2="3" y1="9" y2="9"></line>{" "}
          <line className="ql-stroke" x1="3" x2="3" y1="14" y2="14"></line>{" "}
        </svg>
      </button>
      <button type="button" className="ql-link" aria-label="Insert Link">
        <svg viewBox="0 0 18 18">
          {" "}
          <line className="ql-stroke" x1="7" x2="11" y1="7" y2="11"></line>{" "}
          <path
            className="ql-even ql-stroke"
            d="M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"
          ></path>{" "}
          <path
            className="ql-even ql-stroke"
            d="M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"
          ></path>{" "}
        </svg>
      </button>
    </span>
  </>
);

const ProjectTagField = (props: any) => {
  const {
    values: { project_name },
    touched,
    setFieldValue,
  } = useFormikContext<ProjectForm>();
  const [field, meta] = useField(props);

  useEffect(() => {
    if (project_name.trim() !== "") {
      if (project_name.length <= 3) {
        const tag = project_name.toUpperCase();
        setFieldValue(props.name, tag);
      }
    } else {
      setFieldValue(props.name, "");
    }
  }, [project_name, touched.project_name, setFieldValue, props.name]);

  return (
    <>
      {!!meta.touched && !!meta.error && (
        <span className="auto-prefix">{/* {meta.error} */}-</span>
      )}
      <input className="auto-prefix" {...props} {...field} disabled />
    </>
  );
};

const ProjectModal = ({
  myToast,
  permissions,
  projectShow,
  handleProjectClose,
  setSelectedOption,
  isProjectUpdate,
  isProjectMutate,
  inputField,
  projectListMutate,
  role,
}: {
  projectShow: boolean;
  handleProjectClose: () => void;
  selectProject: React.Dispatch<React.SetStateAction<string | undefined>>;
  inputField: ProjectForm;
  isProjectUpdate: boolean;
  permissions: any;
  setInputField: React.Dispatch<React.SetStateAction<ProjectForm>>;
  isProjectMutate: any;
  projectListMutate: any;
  myToast: any;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
  role: string | undefined;
}) => {
  const [isProjectModelButtonDisabled, setIsProjectModelButtonDisabled] =
    useState(false);
  const [hasShownWarning, setHasShownWarning] = useState(false);

  const typeOfDuration = [
    { _id: "days", value: "Days" },
    { _id: "months", value: "Months" },
    { _id: "years", value: "Years" },
    { _id: "hours", value: "Hours" },
  ];

  const statusOptions = [
    { _id: "In Progress", name: "In Progress" },
    { _id: "Hold", name: "On Hold" },
    { _id: "Yet To Started", name: "Yet To Start" },
  ];

  const nameValidation = Yup.string()
    .matches(
      /^[\w\W]+$/,

      "Only alphanumeric characters and #$:_@- are allowed."
    ) // Allow alphanumeric and selected special characters
    .test(
      "is-valid-combination",
      "Name cannot contain only numbers or only special characters.",
      function (value) {
        if (!value) return false; // Handle empty strings or undefined values
        const hasLetters = /[A-Za-z]/.test(value); // Check if there are letters
        const hasNumbersOrSpecialChars = /[0-9#$:_@-]/.test(value); // Check if there are numbers or special characters

        // Valid if it contains at least one letter, along with optional numbers or special characters
        return (hasLetters && hasNumbersOrSpecialChars) || hasLetters;
      }
    )
    .required("*"); // Required field validation
  const projectFormValidation = Yup.object({
    project_name: nameValidation,
    project_tag: Yup.string().required("*"),
    client: Yup.string().required("*"),
    duration: Yup.string(),
    due_date: Yup.string()
      .test("is-greater-than-start-date", "End date must be greater than start date", function (value) {
        const { start_date } = this.parent;
        if (start_date && value) {
          return new Date(value) >= new Date(start_date);
        }
        return true;
      }),
    status: Yup.string(),
    project_type: Yup.string(),
    description: Yup.string(),
    manager: Yup.string().required("*"),
    leader: Yup.string().required("*"),
    techLeader: Yup.string(),
    estimate_start_date: Yup.string(),
    estimate_end_date: Yup.string()
      .test("is-greater-than-start-date", "End date must be greater than estimated start date", function (value) {
        const { estimate_start_date } = this.parent;
        if (estimate_start_date && value) {
          return new Date(value) >= new Date(estimate_start_date);
        }
        return true;
      }),
    actual_start_date: Yup.string(),
    actual_end_date: Yup.string()
      .test("is-greater-than-start-date", "End date must be greater than actual start date", function (value) {
        const { actual_start_date } = this.parent;
        if (actual_start_date && value) {
          return new Date(value) >= new Date(actual_start_date);
        }
        return true;
      }),
    estimate_time: Yup.string(),
    actual_time: Yup.string(),
    estimate_time_type: Yup.string(),
    actual_time_type: Yup.string(),
    sprint_tag: Yup.string(),
    contributors: Yup.array().of(
      Yup.object().shape({
        _id: Yup.string(),
        profilepic: Yup.string(),
        name: Yup.string(),
      })
    ),
    assignees_visibility: Yup.string(),
  });

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const assgineesOptionTemplate = (option: any) => {
    return (
      <div className="d-flex sm-user-name">
        {/* <img style={{ width: 15 }} src={option.profilepic} /> */}
        <DefaultImage
          src={option.profilepic}
          alt=""
          className=""
          letter={option.name[0]}
          style={{ width: 15 }}
        />
        <div>{option.name}</div>
      </div>
    );
  };

  const selectedAssgineesTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="d-flex sm-user-name">
          {/* <img style={{ width: 15 }} src={option.profilepic} /> */}
          <DefaultImage
            src={option.profilepic}
            alt=""
            className=""
            letter={option.name[0]}
            style={{ width: 15 }}
          />
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const handleProjectForm = async (values: ProjectForm) => {
    values.duration = values.duration
      ? values.duration.concat(" " + values.duration_type)
      : "";
    values.project_type = "List";
    if (values?.contributors && values?.contributors?.length > 0) {
      values?.contributors.map((items) => {
        const found = items?.profilepic?.match(/\/(userprofile(.*))\?/i);
        if (found) {
          items.profilepic = found[1];
        }
        return items;
      });
    } else {
      values.contributors = [];
    }
    try {
      if (isProjectUpdate) {
        const resp = await updateProject(values._id, values);
        if (resp.status === 200) {
          showToast(
            "success",
            "Success Message",
            "Project was updated successfully."
          );
        }
        isProjectMutate();
      } else {
        const {
          project_name,
          project_tag,
          client,
          duration,
          due_date,
          status,
          project_type,
          description,
          manager,
          leader,
          techLeader,
          estimate_start_date,
          estimate_end_date,
          actual_start_date,
          actual_end_date,
          estimate_time,
          actual_time,
          estimate_time_type,
          actual_time_type,
          sprint_tag,
          contributors,
          assignees_visibility,
        } = values;
        const resp = await createProject({
          project_name,
          project_tag,
          client,
          duration,
          due_date,
          status,
          project_type,
          description,
          manager,
          leader,
          techLeader,
          estimate_start_date,
          estimate_end_date,
          actual_start_date,
          actual_end_date,
          estimate_time,
          actual_time,
          estimate_time_type,
          actual_time_type,
          sprint_tag,
          contributors,
          assignees_visibility,
        });
        if (resp.statusCode === 201) {
          showToast(
            "success",
            "Success Message",
            "Project was created successfully."
          );
        }
      }
      projectListMutate();
    } catch (error) {
      console.log(error);
    }
    setSelectedOption("");
    handleProjectClose();
    setIsProjectModelButtonDisabled(false);
  };

  const { assignees } = useAssignees();
  const { clients } = useClientList();

  useEffect(() => {
    if (hasShownWarning) {
      showToast("warn", "Warning", "Kindly fill the required fields!");
    }
  }, [hasShownWarning]);

  return (
    <Dialog
      visible={projectShow}
      onHide={handleProjectClose}
      style={{ width: "50vw" }}
      header={isProjectUpdate ? "Update Project" : "Add a Project"}
      className="details-edit-body dtls-update"
    >
      <Formik
        initialValues={inputField}
        validationSchema={projectFormValidation}
        onSubmit={(values) => {
          setIsProjectModelButtonDisabled(true);
          handleProjectForm(values);
        }}
      >
        {({ errors, values, touched, isSubmitting, setFieldValue }) => {
          if (Object.keys(errors).length > 0 && isSubmitting) {
            setHasShownWarning(true);
          } else {
            setHasShownWarning(false);
          }
          return (
            <Form>
              <div className="modal-body-inner create-project-ui">
                <div className="form-group lg-input">
                  {errors.project_name && touched.project_name ? (
                    <span style={{ color: "red" }}>*</span>
                  ) : null}
                  <Field
                    type="text"
                    name="project_name"
                    placeholder="Type Project Name *"
                  />
                </div>
                <div className="lst-tsk-nm">
                  <div className="dtls-update">
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        PROJECT TAG{" "}
                        {errors.project_tag && touched.project_tag ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <ProjectTagField
                          project_name={values.project_name}
                          type="text"
                          name="project_tag"
                        />
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        CLIENT
                        {errors.client && touched.client ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field name="client">
                          {({ field }: { field: any }) => {
                            return (
                              <Dropdown
                                name="client"
                                optionLabel="client_name"
                                optionValue="_id"
                                value={field.value}
                                onChange={field.onChange}
                                options={clients}
                                placeholder="Select"
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        LEADER
                        {errors.leader && touched.leader ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field name="leader">
                          {({ field }: { field: any }) => {
                            return (
                              <Dropdown
                                name="leader"
                                optionLabel="name"
                                optionValue="_id"
                                value={field.value}
                                onChange={(e) =>
                                  setFieldValue("leader", e.target.value)
                                }
                                options={assignees?.filter(
                                  (e: any) =>
                                    e?.data?.role?.role_name === "Leader"
                                )}
                                itemTemplate={assgineesOptionTemplate}
                                valueTemplate={selectedAssgineesTemplate}
                                placeholder="Select"
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>

                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        MANAGER
                        {errors.manager && touched.manager ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field name="manager">
                          {({ field }: { field: any }) => {
                            return (
                              <Dropdown
                                name="manager"
                                optionLabel="name"
                                optionValue="_id"
                                value={field.value}
                                onChange={(e) =>
                                  setFieldValue("manager", e.target.value)
                                }
                                options={assignees?.filter(
                                  (e: any) =>
                                    e?.data?.role?.role_name === "Manager" ||
                                    e?.data?.role?.role_name === "Leader"
                                )}
                                itemTemplate={assgineesOptionTemplate}
                                valueTemplate={selectedAssgineesTemplate}
                                placeholder="Select"
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>

                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        TECH-LEADER
                        {errors.techLeader && touched.techLeader ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field name="techLeader">
                          {({ field }: { field: any }) => {
                            return (
                              <Dropdown
                                name="techLeader"
                                optionLabel="name"
                                optionValue="_id"
                                value={field.value}
                                onChange={(e) =>
                                  setFieldValue("techLeader", e.target.value)
                                }
                                options={assignees?.filter(
                                  (e: any) =>
                                    e?.data?.role?.role_name === "Leader"
                                )}
                                itemTemplate={assgineesOptionTemplate}
                                valueTemplate={selectedAssgineesTemplate}
                                placeholder="Select"
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    {/* sprint tag */}
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        TAG
                        {errors.sprint_tag && touched.sprint_tag ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field
                          type="text"
                          name="sprint_tag"
                          placeholder="Type Tag *"
                        />
                      </div>
                    </div>

                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        ESTIMATED START DATE
                        {errors?.estimate_start_date && touched?.estimate_start_date ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field name="estimate_start_date">
                          {({ field }: { field: any }) => {
                            return (
                              <Calendar
                                name="estimate_start_date"
                                value={new Date(field.value)}
                                onChange={field.onChange}
                                showIcon
                                icon={"pi pi-calendar"}
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        ESTIMATED END DATE
                        {errors?.estimate_end_date && touched?.estimate_end_date ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field name="estimate_end_date">
                          {({ field }: { field: any }) => {
                            return (
                              <Calendar
                                name="estimate_end_date"
                                value={new Date(field.value)}
                                onChange={field.onChange}
                                showIcon
                                icon={"pi pi-calendar"}
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    {/* Actual  */}
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        ACTUAL START DATE
                        {errors?.actual_start_date && touched?.actual_start_date ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field name="actual_start_date">
                          {({ field }: { field: any }) => {
                            return (
                              <Calendar
                                name="actual_start_date"
                                value={new Date(field.value)}
                                onChange={field.onChange}
                                showIcon
                                icon={"pi pi-calendar"}
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        ACTUAL END DATE
                        {errors?.actual_end_date && touched?.actual_end_date ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field name="actual_end_date">
                          {({ field }: { field: any }) => {
                            return (
                              <Calendar
                                name="actual_end_date"
                                value={new Date(field.value)}
                                onChange={field.onChange}
                                showIcon
                                icon={"pi pi-calendar"}
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>


                    {/* Actual Time & Estimate Time */}
                    <div className="d-flex list-headings">
                      <p className="d-flex">ESTIMATED TIME</p>
                      <div className="drpdwn-slct dtls-update-two-value">
                        <Field
                          type="text"
                          name="estimate_time"
                          placeholder="Enter estimate time in number"
                          onKeyPress={(
                            event: React.KeyboardEvent<HTMLInputElement>
                          ) => {
                            const key = String.fromCharCode(event.which);
                            const input = event.currentTarget.value + key;

                            // Regular expression to allow numbers with up to 2 decimal places
                            const regex = /^\d*\.?\d{0,2}$/;

                            // Check if the resulting value matches the regex
                            if (!regex.test(input)) {
                              event.preventDefault();
                            }
                          }}
                          min="0"
                        />
                        <Field name="estimate_time_type">
                          {({ field }: { field: any }) => {
                            return (
                              <Dropdown
                                name="estimate_time_type"
                                optionLabel="value"
                                optionValue="_id"
                                value={field.value}
                                onChange={field.onChange}
                                options={typeOfDuration}
                                placeholder="Select"
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">ACTUAL TIME</p>
                      <div className="drpdwn-slct dtls-update-two-value">
                        <Field
                          type="text"
                          name="actual_time"
                          placeholder="Enter actual time in number"
                          onKeyPress={(
                            event: React.KeyboardEvent<HTMLInputElement>
                          ) => {
                            const key = String.fromCharCode(event.which);
                            const input = event.currentTarget.value + key;

                            // Regular expression to allow numbers with up to 2 decimal places
                            const regex = /^\d*\.?\d{0,2}$/;

                            // Check if the resulting value matches the regex
                            if (!regex.test(input)) {
                              event.preventDefault();
                            }
                          }}
                          min="0"
                        />
                        <Field name="actual_time_type">
                          {({ field }: { field: any }) => {
                            return (
                              <Dropdown
                                name="actual_time_type"
                                optionLabel="value"
                                optionValue="_id"
                                value={field.value}
                                onChange={field.onChange}
                                options={typeOfDuration}
                                placeholder="Select"
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">DURATION</p>
                      <div className="drpdwn-slct dtls-update-two-value">
                        <Field
                          type="text"
                          name="duration"
                          placeholder="Enter duration in number"
                          onKeyPress={(
                            event: React.KeyboardEvent<HTMLInputElement>
                          ) => {
                            const key = String.fromCharCode(event.which);
                            const input = event.currentTarget.value + key;

                            // Regular expression to allow numbers with up to 2 decimal places
                            const regex = /^\d*\.?\d{0,2}$/;

                            // Check if the resulting value matches the regex
                            if (!regex.test(input)) {
                              event.preventDefault();
                            }
                          }}
                          min="0"
                        />
                        <Field name="duration_type">
                          {({ field }: { field: any }) => {
                            return (
                              <Dropdown
                                name="duration_type"
                                optionLabel="value"
                                optionValue="_id"
                                value={field.value}
                                onChange={field.onChange}
                                options={typeOfDuration}
                                placeholder="Select"
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>

                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        EXPECTED END DATE
                        {errors.due_date && touched.due_date ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field name="due_date">
                          {({ field }: { field: any }) => {
                            return (
                              <Calendar
                                name="due_date"
                                value={new Date(field.value)}
                                onChange={field.onChange}
                                showIcon
                                icon={"pi pi-calendar"}
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>

                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        STATUS
                        {errors.status && touched.status ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field name="status">
                          {({ field }: { field: any }) => {
                            return (
                              <Dropdown
                                name="status"
                                optionLabel="name"
                                optionValue="_id"
                                value={field.value}
                                onChange={field.onChange}
                                options={statusOptions}
                                placeholder="Select"
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        TYPE
                        {errors.project_type && touched.project_type ? (
                          <span style={{ color: "red" }}></span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <div className="check-label-ui">
                          <RadioButton
                            inputId="project_type"
                            id="list-radio"
                            name="project_type"
                            value="List"
                            //onChange={(e) => { setFieldValue("project_type", 'List') }}
                            //checked={values.project_type === 'List'}
                            checked
                          />
                          <label
                            htmlFor="list-radio"
                            className="p-radiobutton-label"
                          >
                            <span>Lists</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex dtls-update">
                  <div className="list-headings description">
                    <p className="d-flex">Description</p>
                    <Editor
                      className="lst-tsk-nm"
                      id="description"
                      value={values.description}
                      onTextChange={(e) => {
                        setFieldValue("description", e.htmlValue);
                      }}
                      headerTemplate={header}
                    />
                  </div>
                  <div className="assignees">
                    <div className="assignees-item">
                      <p className="d-flex assignees-for">ASSIGNEES </p>
                      <SelectContributors
                        // assigneesList={assignees}
                        assigneesList={assignees.filter(
                          (assignee) =>
                            !values.contributors.some(
                              (selected) => selected._id === assignee._id
                            )
                        )}
                        assignees={values.contributors}
                        leader={values.leader}
                        manager={values.manager}
                        isProjectUpdate={isProjectUpdate}
                        name="contributor"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer foo-check-ui">
                <div className="p-col-3">
                  <div className="flex-align-center">
                    <Checkbox
                      name="assignees_visibility"
                      onChange={(e) => {
                        // Toggle the value based on the current state
                        setFieldValue(
                          "assignees_visibility",
                          !values?.assignees_visibility
                        );
                      }}
                      checked={values?.assignees_visibility}
                    //checked
                    />
                    <label className="p-radiobutton-label">
                      Only visible to Members
                    </label>
                  </div>
                </div>
                {hasPermission(permissions, ["projects:write"]) && (
                  <div className="buttonGroup d-flex">
                    <button
                      type="button"
                      className="btn cancel"
                      data-bs-dismiss="modal"
                      onClick={handleProjectClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn save"
                      disabled={isProjectModelButtonDisabled || isSubmitting}
                    >
                      {isProjectUpdate ? "Save" : "Add"}
                    </button>
                  </div>
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

const ProjectDetailsModel = ({
  myToast,
  permissions,
  projectDetailsShow,
  handleProjectClose,
  setSelectedOption,
  isProjectUpdate,
  isProjectMutate,
  inputField,
  projectListMutate,
  role,
  handleProjectDetailsClose,
}: {
  projectDetailsShow: boolean;
  handleProjectClose: () => void;
  selectProject: React.Dispatch<React.SetStateAction<string | undefined>>;
  inputField: ProjectForm;
  isProjectUpdate: boolean;
  permissions: any;
  setInputField: React.Dispatch<React.SetStateAction<ProjectForm>>;
  isProjectMutate: any;
  projectListMutate: any;
  myToast: any;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
  role: string | undefined;
  handleProjectDetailsClose: () => void;
}) => {
  const [isProjectDetailsButtonDisabled, setIsProjectDetailsButtonDisabled] =
    useState(false);
  const [hasShownWarning, setHasShownWarning] = useState(false);

  const typeOfDuration = [
    { _id: "days", value: "Days" },
    { _id: "months", value: "Months" },
    { _id: "years", value: "Years" },
    { _id: "hours", value: "Hours" },
  ];

  const statusOptions = [
    { _id: "In Progress", name: "In Progress" },
    { _id: "Hold", name: "On Hold" },
    { _id: "Yet To Started", name: "Yet To Start" },
  ];

  const nameValidation = Yup.string()
    .matches(
      /^[\w\W]+$/,

      "Only alphanumeric characters and #$:_@- are allowed."
    ) // Allow alphanumeric and selected special characters
    .test(
      "is-valid-combination",
      "Name cannot contain only numbers or only special characters.",
      function (value) {
        if (!value) return false; // Handle empty strings or undefined values
        const hasLetters = /[A-Za-z]/.test(value); // Check if there are letters
        const hasNumbersOrSpecialChars = /[0-9#$:_@-]/.test(value); // Check if there are numbers or special characters

        // Valid if it contains at least one letter, along with optional numbers or special characters
        return (hasLetters && hasNumbersOrSpecialChars) || hasLetters;
      }
    )
    .required("*"); // Required field validation
  const projectFormValidation = Yup.object({
    project_name: nameValidation,
    project_tag: Yup.string().required("*"),
    client: Yup.string().required("*"),
    duration: Yup.string(),
    due_date: Yup.string()
      .test("is-greater-than-start-date", "End date must be greater than start date", function (value) {
        const { start_date } = this.parent;
        if (start_date && value) {
          return new Date(value) >= new Date(start_date);
        }
        return true;
      }),
    status: Yup.string(),
    project_type: Yup.string(),
    description: Yup.string(),
    manager: Yup.string().required("*"),
    leader: Yup.string().required("*"),
    techLeader: Yup.string(),
    estimate_start_date: Yup.string(),
    estimate_end_date: Yup.string()
      .test("is-greater-than-start-date", "End date must be greater than estimated start date", function (value) {
        const { estimate_start_date } = this.parent;
        if (estimate_start_date && value) {
          return new Date(value) >= new Date(estimate_start_date);
        }
        return true;
      }), actual_start_date: Yup.string(),
    actual_end_date: Yup.string()
      .test("is-greater-than-start-date", "End date must be greater than actual start date", function (value) {
        const { actual_start_date } = this.parent;
        if (actual_start_date && value) {
          return new Date(value) >= new Date(actual_start_date);
        }
        return true;
      }), estimate_time: Yup.string(),
    actual_time: Yup.string(),
    estimate_time_type: Yup.string(),
    actual_time_type: Yup.string(),
    sprint_tag: Yup.string(),
    contributors: Yup.array().of(
      Yup.object().shape({
        _id: Yup.string(),
        profilepic: Yup.string(),
        name: Yup.string(),
      })
    ),
    assignees_visibility: Yup.string(),
  });

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const assgineesOptionTemplate = (option: any) => {
    return (
      <div className="d-flex sm-user-name">
        {/* <img style={{ width: 15 }} src={option.profilepic} /> */}
        <DefaultImage
          src={option.profilepic}
          alt=""
          className=""
          letter={option.name[0]}
          style={{ width: 15 }}
        />
        <div>{option.name}</div>
      </div>
    );
  };

  const selectedAssgineesTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="d-flex sm-user-name">
          {/* <img style={{ width: 15 }} src={option.profilepic} /> */}
          <DefaultImage
            src={option.profilepic}
            alt=""
            className=""
            letter={option.name[0]}
            style={{ width: 15 }}
          />
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const handleProjectForm = async (values: ProjectForm) => {
    values.duration = values.duration
      ? values.duration.concat(" " + values.duration_type)
      : "";
    values.project_type = "List";
    if (values?.contributors && values?.contributors?.length > 0) {
      values?.contributors?.map((items) => {
        const found = items?.profilepic?.match(/\/(userprofile(.*))\?/i);
        if (found) {
          items.profilepic = found[1];
        }
        return items;
      });
    } else {
      values.contributors = [];
    }
    try {
      if (isProjectUpdate) {
        const resp = await updateProject(values?._id, values);
        if (resp.status === 200) {
          showToast(
            "success",
            "Success Message",
            "Project was updated successfully."
          );
        }
        isProjectMutate();
      } else {
        const {
          project_name,
          project_tag,
          client,
          duration,
          due_date,
          status,
          project_type,
          description,
          manager,
          leader,
          techLeader,
          estimate_start_date,
          estimate_end_date,
          actual_start_date,
          actual_end_date,
          estimate_time,
          actual_time,
          estimate_time_type,
          actual_time_type,
          sprint_tag,
          contributors,
          assignees_visibility,
        } = values;
        const resp = await createProject({
          project_name,
          project_tag,
          client,
          duration,
          due_date,
          status,
          project_type,
          description,
          manager,
          leader,
          techLeader,
          estimate_start_date,
          estimate_end_date,
          actual_start_date,
          actual_end_date,
          estimate_time,
          actual_time,
          estimate_time_type,
          actual_time_type,
          sprint_tag,
          contributors,
          assignees_visibility,
        });
        if (resp.statusCode === 201) {
          showToast(
            "success",
            "Success Message",
            "Project was created successfully."
          );
        }
      }
      projectListMutate();
    } catch (error) {
      console.log(error);
    }
    setSelectedOption("");
    handleProjectDetailsClose();
    setIsProjectDetailsButtonDisabled(false);
  };

  const { assignees } = useAssignees();
  const { clients } = useClientList();

  useEffect(() => {
    if (hasShownWarning) {
      showToast("warn", "Warning", "Kindly fill the required fields!");
    }
  }, [hasShownWarning]);

  return (
    <Dialog
      visible={projectDetailsShow}
      onHide={handleProjectDetailsClose}
      style={{ width: "50vw" }}
      header={
        hasPermission(permissions, ["projects:write"])
          ? "Update Project"
          : "View Project"
      }
      className="details-edit-body dtls-update"
    >
      <Formik
        initialValues={inputField}
        validationSchema={projectFormValidation}
        onSubmit={(values) => {
          setIsProjectDetailsButtonDisabled(true);
          handleProjectForm(values);
        }}
      >
        {({ errors, values, touched, isSubmitting, setFieldValue }) => {
          if (Object.keys(errors).length > 0 && isSubmitting) {
            setHasShownWarning(true);
          } else {
            setHasShownWarning(false);
          }
          return (
            <Form>
              <div className="modal-body-inner create-project-ui">
                {hasPermission(permissions, ["projects:write"]) ? (
                  <div className="form-group lg-input">
                    {errors.project_name && touched.project_name ? (
                      <span style={{ color: "red" }}>*</span>
                    ) : null}
                    <Field
                      type="text"
                      name="project_name"
                      placeholder="Type Project Name *"
                    />
                  </div>
                ) : (
                  <div className="form-group lg-input">
                    {errors.project_name && touched.project_name ? (
                      <span style={{ color: "red" }}>*</span>
                    ) : null}
                    <Field
                      type="text"
                      name="project_name"
                      placeholder="Type Project Name *"
                      readOnly
                    />
                  </div>
                )}
                <div className="lst-tsk-nm">
                  <div className="dtls-update">
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        PROJECT TAG{" "}
                        {errors.project_tag && touched.project_tag ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <ProjectTagField
                          project_name={values.project_name}
                          type="text"
                          name="project_tag"
                        />
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        CLIENT
                        {errors.client && touched.client ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      {hasPermission(permissions, ["projects:write"]) ? (
                        <div className="drpdwn-slct">
                          <Field name="client">
                            {({ field }: { field: any }) => {
                              return (
                                <Dropdown
                                  name="client"
                                  optionLabel="client_name"
                                  optionValue="_id"
                                  value={field.value}
                                  onChange={field.onChange}
                                  options={clients}
                                  placeholder="Select"
                                />
                              );
                            }}
                          </Field>
                        </div>
                      ) : (
                        <div className="drpdwn-slct">
                          <Field name="client">
                            {({ field }: { field: any }) => {
                              return (
                                <Dropdown
                                  name="client"
                                  optionLabel="client_name"
                                  optionValue="_id"
                                  value={field.value}
                                  onChange={field.onChange}
                                  options={clients}
                                  placeholder="Select"
                                  disabled
                                />
                              );
                            }}
                          </Field>
                        </div>
                      )}
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        LEADER
                        {errors.leader && touched.leader ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      {hasPermission(permissions, ["projects:write"]) ? (
                        <div className="drpdwn-slct">
                          <Field name="leader">
                            {({ field }: { field: any }) => {
                              return (
                                <Dropdown
                                  name="leader"
                                  optionLabel="name"
                                  optionValue="_id"
                                  value={field.value}
                                  onChange={(e) =>
                                    setFieldValue("leader", e.target.value)
                                  }
                                  options={assignees?.filter(
                                    (e: any) =>
                                      e?.data?.role?.role_name === "Leader"
                                  )}
                                  itemTemplate={assgineesOptionTemplate}
                                  valueTemplate={selectedAssgineesTemplate}
                                  placeholder="Select"
                                />
                              );
                            }}
                          </Field>
                        </div>
                      ) : (
                        <div className="drpdwn-slct">
                          <Field name="leader">
                            {({ field }: { field: any }) => {
                              return (
                                <Dropdown
                                  name="leader"
                                  optionLabel="name"
                                  optionValue="_id"
                                  value={field.value}
                                  onChange={(e) =>
                                    setFieldValue("leader", e.target.value)
                                  }
                                  options={assignees?.filter(
                                    (e: any) =>
                                      e?.data?.role?.role_name === "Leader"
                                  )}
                                  itemTemplate={assgineesOptionTemplate}
                                  valueTemplate={selectedAssgineesTemplate}
                                  placeholder="Select"
                                  disabled
                                />
                              );
                            }}
                          </Field>
                        </div>
                      )}
                    </div>

                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        MANAGER
                        {errors.manager && touched.manager ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      {hasPermission(permissions, ["projects:write"]) ? (
                        <div className="drpdwn-slct">
                          <Field name="manager">
                            {({ field }: { field: any }) => {
                              return (
                                <Dropdown
                                  name="manager"
                                  optionLabel="name"
                                  optionValue="_id"
                                  value={field.value}
                                  onChange={(e) =>
                                    setFieldValue("manager", e.target.value)
                                  }
                                  options={assignees?.filter(
                                    (e: any) =>
                                      e?.data?.role?.role_name === "Manager"
                                  )}
                                  itemTemplate={assgineesOptionTemplate}
                                  valueTemplate={selectedAssgineesTemplate}
                                  placeholder="Select"
                                />
                              );
                            }}
                          </Field>
                        </div>
                      ) : (
                        <div className="drpdwn-slct">
                          <Field name="manager">
                            {({ field }: { field: any }) => {
                              return (
                                <Dropdown
                                  name="manager"
                                  optionLabel="name"
                                  optionValue="_id"
                                  value={field.value}
                                  onChange={(e) =>
                                    setFieldValue("manager", e.target.value)
                                  }
                                  options={assignees?.filter(
                                    (e: any) =>
                                      e?.data?.role?.role_name === "Manager"
                                  )}
                                  itemTemplate={assgineesOptionTemplate}
                                  valueTemplate={selectedAssgineesTemplate}
                                  placeholder="Select"
                                  disabled
                                />
                              );
                            }}
                          </Field>
                        </div>
                      )}
                    </div>

                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        TECH-LEADER
                        {errors.techLeader && touched.techLeader ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      {hasPermission(permissions, ["projects:write"]) ? (
                        <div className="drpdwn-slct">
                          <Field name="techLeader">
                            {({ field }: { field: any }) => {
                              return (
                                <Dropdown
                                  name="techLeader"
                                  optionLabel="name"
                                  optionValue="_id"
                                  value={field.value}
                                  onChange={(e) =>
                                    setFieldValue("techLeader", e.target.value)
                                  }
                                  options={assignees?.filter(
                                    (e: any) =>
                                      e?.data?.role?.role_name === "Leader"
                                  )}
                                  itemTemplate={assgineesOptionTemplate}
                                  valueTemplate={selectedAssgineesTemplate}
                                  placeholder="Select"
                                />
                              );
                            }}
                          </Field>
                        </div>
                      ) : (
                        <div className="drpdwn-slct">
                          <Field name="techLeader">
                            {({ field }: { field: any }) => {
                              return (
                                <Dropdown
                                  name="techLeader"
                                  optionLabel="name"
                                  optionValue="_id"
                                  value={field.value}
                                  onChange={(e) =>
                                    setFieldValue("techLeader", e.target.value)
                                  }
                                  options={assignees?.filter(
                                    (e: any) =>
                                      e?.data?.role?.role_name === "Leader"
                                  )}
                                  itemTemplate={assgineesOptionTemplate}
                                  valueTemplate={selectedAssgineesTemplate}
                                  placeholder="Select"
                                  disabled
                                />
                              );
                            }}
                          </Field>
                        </div>
                      )}
                    </div>

                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        TAG
                        {errors.sprint_tag && touched.sprint_tag ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      {hasPermission(permissions, ["projects:write"]) ? (
                        <div className="drpdwn-slct">

                          <Field
                            type="text"
                            name="sprint_tag"
                            placeholder="Type  Tag *"
                          />
                        </div>
                      ) : (
                        <div className="drpdwn-slct">
                          <Field name="sprint_tag" readOnly />
                        </div>
                      )}
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        ESTIMATED START DATE
                        {errors.estimate_start_date && touched.estimate_start_date ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      {hasPermission(permissions, ["projects:write"]) ? (
                        <div className="drpdwn-slct">
                          <Field name="estimate_start_date">
                            {({ field }: { field: any }) => {
                              return (
                                <Calendar
                                  name="estimate_start_date"
                                  value={new Date(field.value)}
                                  onChange={field.onChange}
                                  showIcon
                                  icon={"pi pi-calendar"}
                                />
                              );
                            }}
                          </Field>
                        </div>
                      ) : (
                        <div className="drpdwn-slct">
                          <Field name="estimate_start_date" readOnly></Field>
                        </div>
                      )}
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        ESTIMATED END DATE
                        {errors.estimate_end_date && touched.estimate_end_date ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      {hasPermission(permissions, ["projects:write"]) ? (
                        <div className="drpdwn-slct">
                          <Field name="estimate_end_date">
                            {({ field }: { field: any }) => {
                              return (
                                <Calendar
                                  name="estimate_end_date"
                                  value={new Date(field.value)}
                                  onChange={field.onChange}
                                  showIcon
                                  icon={"pi pi-calendar"}
                                />
                              );
                            }}
                          </Field>
                        </div>
                      ) : (
                        <div className="drpdwn-slct">
                          <Field name="estimate_end_date" readOnly></Field>
                        </div>
                      )}
                    </div>
                    {/* Actual Date */}
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        ACTUAL START DATE
                        {errors.actual_start_date && touched.actual_start_date ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      {hasPermission(permissions, ["projects:write"]) ? (
                        <div className="drpdwn-slct">
                          <Field name="actual_start_date">
                            {({ field }: { field: any }) => {
                              return (
                                <Calendar
                                  name="actual_start_date"
                                  value={new Date(field.value)}
                                  onChange={field.onChange}
                                  showIcon
                                  icon={"pi pi-calendar"}
                                />
                              );
                            }}
                          </Field>
                        </div>
                      ) : (
                        <div className="drpdwn-slct">
                          <Field name="actual_start_date" readOnly></Field>
                        </div>
                      )}
                    </div> <div className="d-flex list-headings">
                      <p className="d-flex">
                        ACTUAL END DATE
                        {errors.actual_end_date && touched.actual_end_date ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      {hasPermission(permissions, ["projects:write"]) ? (
                        <div className="drpdwn-slct">
                          <Field name="actual_end_date">
                            {({ field }: { field: any }) => {
                              return (
                                <Calendar
                                  name="actual_end_date"
                                  value={new Date(field.value)}
                                  onChange={field.onChange}
                                  showIcon
                                  icon={"pi pi-calendar"}
                                />
                              );
                            }}
                          </Field>
                        </div>
                      ) : (
                        <div className="drpdwn-slct">
                          <Field name="actual_end_date" readOnly></Field>
                        </div>
                      )}
                    </div>
                    {/* Actual Time & Estimate Time */}
                    {/* <div className="d-flex list-headings">
                      <p className="d-flex">ESTIMATED TIME</p>
                      {hasPermission(permissions, ["projects:write"]) ? (
                        <div className="drpdwn-slct dtls-update-two-value">
                          <Field
                            type="text"
                            name="estimate_time"
                            placeholder="Enter estimate time in number"
                            onKeyPress={(
                              event: React.KeyboardEvent<HTMLInputElement>
                            ) => {
                              const key = String.fromCharCode(event.which);
                              const input = event.currentTarget.value + key;

                              // Regular expression to allow numbers with up to 2 decimal places
                              const regex = /^\d*\.?\d{0,2}$/;

                              // Check if the resulting value matches the regex
                              if (!regex.test(input)) {
                                event.preventDefault();
                              }
                            }}
                            min="0"
                          />
                          <Field name="estimate_time_type">
                            {({ field }: { field: any }) => {
                              return (
                                <Dropdown
                                  name="estimate_time_type"
                                  optionLabel="value"
                                  optionValue="_id"
                                  value={field.value}
                                  onChange={field.onChange}
                                  options={typeOfDuration}
                                  placeholder="Select"
                                />
                              );
                            }}
                          </Field>
                        </div>
                      ) : (
                        <div className="drpdwn-slct dtls-update-two-value">
                          <Field
                            type="text"
                            name="estimate_time"
                            placeholder="Enter estimate time in number"
                            readOnly
                          />
                          <Field name="estimate_time_type" readOnly></Field>
                        </div>
                      )}
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">ACTUAL TIME</p>
                      {hasPermission(permissions, ["projects:write"]) ? (
                        <div className="drpdwn-slct dtls-update-two-value">
                          <Field
                            type="text"
                            name="actual_time"
                            placeholder="Enter actual time in number"
                            onKeyPress={(
                              event: React.KeyboardEvent<HTMLInputElement>
                            ) => {
                              const key = String.fromCharCode(event.which);
                              const input = event.currentTarget.value + key;

                              // Regular expression to allow numbers with up to 2 decimal places
                              const regex = /^\d*\.?\d{0,2}$/;

                              // Check if the resulting value matches the regex
                              if (!regex.test(input)) {
                                event.preventDefault();
                              }
                            }}
                            min="0"
                          />
                          <Field name="actual_time_type">
                            {({ field }: { field: any }) => {
                              return (
                                <Dropdown
                                  name="actual_time_type"
                                  optionLabel="value"
                                  optionValue="_id"
                                  value={field.value}
                                  onChange={field.onChange}
                                  options={typeOfDuration}
                                  placeholder="Select"
                                />
                              );
                            }}
                          </Field>
                        </div>
                      ) : (
                        <div className="drpdwn-slct dtls-update-two-value">
                          <Field
                            type="text"
                            name="actual_time"
                            placeholder="Enter estimate time in number"
                            readOnly
                          />
                          <Field name="actual_time_type" readOnly></Field>
                        </div>
                      )}
                    </div> */}
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        EXPECTED END DATE
                        {errors.due_date && touched.due_date ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      {hasPermission(permissions, ["projects:write"]) ? (
                        <div className="drpdwn-slct">
                          <Field name="due_date">
                            {({ field }: { field: any }) => {
                              return (
                                <Calendar
                                  name="due_date"
                                  value={new Date(field.value)}
                                  onChange={field.onChange}
                                  showIcon
                                  icon={"pi pi-calendar"}
                                />
                              );
                            }}
                          </Field>
                        </div>
                      ) : (
                        <div className="drpdwn-slct">
                          <Field name="due_date" readOnly></Field>
                        </div>
                      )}
                    </div>

                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        STATUS
                        {errors.status && touched.status ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      {hasPermission(permissions, ["projects:write"]) ? (
                        <div className="drpdwn-slct">
                          <Field name="status">
                            {({ field }: { field: any }) => {
                              return (
                                <Dropdown
                                  name="status"
                                  optionLabel="name"
                                  optionValue="_id"
                                  value={field.value}
                                  onChange={field.onChange}
                                  options={statusOptions}
                                  placeholder="Select"
                                />
                              );
                            }}
                          </Field>
                        </div>
                      ) : (
                        <div className="drpdwn-slct">
                          <Field name="status" readOnly></Field>
                        </div>
                      )}
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        TYPE
                        {errors.project_type && touched.project_type ? (
                          <span style={{ color: "red" }}></span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <div className="check-label-ui">
                          <RadioButton
                            inputId="project_type"
                            id="list-radio"
                            name="project_type"
                            value="List"
                            //onChange={(e) => { setFieldValue("project_type", 'List') }}
                            //checked={values.project_type === 'List'}
                            checked
                          />
                          <label
                            htmlFor="list-radio"
                            className="p-radiobutton-label"
                          >
                            <span>Lists</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex dtls-update">
                  {hasPermission(permissions, ["projects:write"]) ? (
                    <div className="list-headings description">
                      <p className="d-flex">Description</p>
                      <Editor
                        className="lst-tsk-nm"
                        id="description"
                        value={values.description}
                        onTextChange={(e) => {
                          setFieldValue("description", e.htmlValue);
                        }}
                        headerTemplate={header}
                      />
                    </div>
                  ) : (
                    <div className="list-headings description">
                      <p className="d-flex">Description</p>
                      <Editor
                        className="lst-tsk-nm"
                        id="description"
                        value={values.description}
                        onTextChange={(e) => {
                          setFieldValue("description", e.htmlValue);
                        }}
                        headerTemplate={header}
                        readOnly
                      />
                    </div>
                  )}
                  {hasPermission(permissions, ["projects:write"]) ? (
                    <div className="assignees">
                      <div className="assignees-item">
                        <p className="d-flex assignees-for">ASSIGNEES </p>
                        <SelectContributors
                          // assigneesList={assignees}
                          assigneesList={assignees.filter(
                            (assignee) =>
                              !values.contributors.some(
                                (selected) => selected._id === assignee._id
                              )
                          )}
                          assignees={values.contributors}
                          leader={values.leader}
                          manager={values.manager}
                          isProjectUpdate={isProjectUpdate}
                          name="contributor"
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="assignees">
                      <div className="assignees-item">
                        <p className="d-flex assignees-for mb-1">ASSIGNEES </p>
                        <SelectContributorsView
                          assigneesList={assignees}
                          assignees={values.contributors}
                          leader={values.leader}
                          manager={values.manager}
                          isProjectUpdate={isProjectUpdate}
                          name="contributor"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="modal-footer foo-check-ui">
                {hasPermission(permissions, ["projects:write"]) ? (
                  <div className="p-col-3">
                    <div className="flex-align-center">
                      <Checkbox
                        name="assignees_visibility"
                        onChange={(e) => {
                          // Toggle the value based on the current state
                          setFieldValue(
                            "assignees_visibility",
                            !values?.assignees_visibility
                          );
                        }}
                        checked={values?.assignees_visibility}
                      />
                      <label className="p-radiobutton-label">
                        Only visible to Members
                      </label>
                    </div>
                  </div>
                ) : (
                  <div className="p-col-3">
                    <div className="flex-align-center">
                      <Checkbox
                        name="assignees_visibility"
                        // onChange={(e) => { setFieldValue("assignees_visibility", false) }}
                        checked={values.assignees_visibility}
                      />
                      <label className="p-radiobutton-label">
                        Only visible to Members
                      </label>
                    </div>
                  </div>
                )}
                {hasPermission(permissions, ["projects:write"]) && (
                  <div className="buttonGroup d-flex">
                    <button
                      type="button"
                      className="btn cancel"
                      data-bs-dismiss="modal"
                      onClick={handleProjectDetailsClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn save"
                      disabled={isProjectDetailsButtonDisabled || isSubmitting}
                    >
                      {isProjectUpdate ? "Save" : "Add"}
                    </button>
                  </div>
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

const TaskSidePanel = ({
  myToast,
  closeSidePanel,
  taskDetails,
  selectedAssignee,
  selectedStatus,
  selectedSort,
  selectedSprint,
  refreshTaskList,
}: {
  taskDetails: TaskType;
  myToast: any;
  closeSidePanel: () => void;
  selectedAssignee: string;
  selectedStatus: string;
  selectedSort: string;
  selectedSprint: string;
  refreshTaskList: any;
}) => {
  const {
    taskId,
    name,
    members,
    status,
    _id,
    due_date,
    priority,
    subTasks,
    projectId,
    start_date,
    reference_taskId,
    estimation_time,
    actual_time,
    actual_start_date,
    actual_due_date,
    log_time,
    description,
    documents,
    statusId,
    sprint_tag,
  } = taskDetails;
  const [isTaskSidePanelButtonDisabled, setIsTaskSidePanelButtonDisabled] =
    useState(false);
    const [hasShownWarning, setHasShownWarning] = useState(false);

  const { projectAssignees, isLoading: projectAssigneesReady } =
    useProjectAssignees(projectId);
  const { taskStatus } = useTaskStatus();
  const { taskList } = useTaskList(
    projectId,
    selectedAssignee,
    selectedStatus,
    selectedSort,
    selectedSprint,
  );

  const taskForm: TaskForm = {
    _id,
    name,
    status: statusId,
    priority,
    estimation_time,
    actual_time,
    actual_time_type: "",
    estimation_time_type: "",
    log_time,
    start_date: dateBeautify(start_date),
    due_date: dateBeautify(due_date),
    actual_start_date: actual_start_date ? dateBeautify(actual_start_date) : "",
    actual_due_date: actual_due_date ? dateBeautify(actual_due_date) : "",
    reference_taskId,
    sprint_tag,
    description,
    projectId,
    members,
    subTasks,
    documents,
    member: "",
  };


  const nameValidation = Yup.string()
    .matches(
      /^[\w\W]+$/,

      "Only alphanumeric characters and #$:_@- are allowed."
    ) // Allow alphanumeric and selected special characters
    .test(
      "is-valid-combination",
      "Name cannot contain only numbers or only special characters.",
      function (value) {
        if (!value) return false; // Handle empty strings or undefined values
        const hasLetters = /[A-Za-z]/.test(value); // Check if there are letters
        const hasNumbersOrSpecialChars = /[0-9#$:_@-]/.test(value); // Check if there are numbers or special characters

        // Valid if it contains at least one letter, along with optional numbers or special characters
        return (hasLetters && hasNumbersOrSpecialChars) || hasLetters;
      }
    )
    .required("*"); // Required field validation

    useEffect(() => {
      if (hasShownWarning) {
        showToast("warn", "Warning", "Kindly fill the required fields!");
      }
    }, [hasShownWarning]);

  const taskFormValidation = Yup.object({
    name: nameValidation,
    status: Yup.string(),
    priority: Yup.string(),
    estimation_time: Yup.number(),
    estimation_time_type: Yup.string(),
    actual_time: Yup.number(),
    actual_time_type: Yup.string(),
    log_time: Yup.number(),
    start_date: Yup.string(),
    due_date: Yup.string()
      .test("is-greater-than-start-date", "End date must be greater than start date", function (value) {
        const { start_date } = this.parent;
        if (start_date && value) {
          return new Date(value) >= new Date(start_date);
        }
        return true;
      }),
    actual_start_date: Yup.string(),
    actual_due_date: Yup.string()
      .test("is-greater-than-start-date", "End date must be greater than actual start date", function (value) {
        const { actual_start_date } = this.parent;
        if (actual_start_date && value) {
          return new Date(value) >= new Date(actual_start_date);
        }
        return true;
      }),
    reference_taskId: Yup.string(),
    description: Yup.string().required("*"),
    projectId: Yup.string().required("*"),
    members: Yup.array()
      .of(
        Yup.object().shape({
          _id: Yup.string().required("*"),
          profilepic: Yup.string(),
          name: Yup.string().required("*"),
        })
      )
      .min(1, "At least one member is required."),
    subTasks: Yup.array(),
    documents: Yup.array(),
    sprint_tag: Yup.string()
      .matches(/^[A-Za-z0-9 ]+$/, "Only letters, numbers, and spaces are allowed")
      .trim()
      .max(30, "Tag cannot exceed 30 characters")
  });

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const canEditOrRemove = () => {
    const employeeId = localStorage.getItem("employeeId");
    const currentUserRole = localStorage.getItem('currentUserRole');
    const userId = localStorage.getItem("userId");
    const isContributor = (
      currentUserRole?.toLowerCase() === 'contributor'
    )
    const isCreator = taskDetails?.createdBy?.[0]?._id === userId;
    const isAssignee = taskDetails?.members?.some(
      (member) => member?._id === employeeId
    );
    // Contributor can only edit/remove if they are creator or an assignee
    if (isContributor) {
      return isCreator || isAssignee;
    }

    // Non-contributors can edit without restrictions
    return checkPermission("tasks:write");
  };



  const handleTaskForm = async (values: TaskForm) => {
    if (values?.members && values?.members?.length > 0) {
      values?.members?.map((items) => {
        const found = items?.profilepic?.match(/\/(userprofile(.*))\?/i);
        if (found) {
          items.profilepic = found[1];
        }
        return items;
      });
    } else {
      values.members = [];
    }

    try {
      const resp = await updateTask(values._id, values);
      if (resp.status == 200) {
        showToast(
          "success",
          "Success Message",
          "Task was updated successfully."
        );
      }

      closeSidePanel();
      setIsTaskSidePanelButtonDisabled(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={taskForm}
        validationSchema={taskFormValidation}
        onSubmit={(values) => {
          setIsTaskSidePanelButtonDisabled(true);
          handleTaskForm(values);
        }}
      >
        {({ values, setFieldValue, isSubmitting, errors, touched }) => {
  if (Object.keys(errors).length > 0 && isSubmitting) {
    setHasShownWarning(true);
  } else {
    setHasShownWarning(false);
  }
          return (
            <Form style={{ width: "100%" }}>
              <div className="details-body">
                <div className="md-padding tsk-head">
                  <div className="d-flex lst-tsk-nm">
                    <input
                      type="text"
                      className="tsk-nm"
                      value={taskDetails.name}
                      disabled
                    />
                    {/* <p className='tsk-nm'></p> */}
                  </div>
                </div>
                <div className="tab-detailed-sec md-padding">
                  <div className="lst-tsk-nm dtls-update">
                    <div className="d-flex list-headings">
                      <p className="d-flex">status</p>
                      <div className="drpdwn-slct">
                        <Field name="status">
                          {({ field }: { field: any }) => (
                            <select {...field}>
                              {taskStatus.map((status) => (
                                <option key={status._id} value={status._id}>
                                  {status.name}
                                </option>
                              ))}
                            </select>
                          )}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">priority</p>
                      <div className="drpdwn-slct">
                        <Field name="priority">
                          {({ field }: { field: any }) => (
                            <select {...field}>
                              <option value="">Select</option>
                              <option defaultValue="High">High</option>
                              <option value="Medium">Medium</option>
                              <option value="Low">Low</option>
                            </select>
                          )}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">ESTIMATED TIME (HRS)</p>
                      <div className="drpdwn-slct">
                        <Field
                          name="estimation_time"
                          type="text"
                          onKeyPress={(
                            event: React.KeyboardEvent<HTMLInputElement>
                          ) => {
                            const key = String.fromCharCode(event.which);
                            const input = event.currentTarget.value + key;

                            // Regular expression to allow numbers with up to 2 decimal places
                            const regex = /^\d*\.?\d{0,2}$/;

                            // Check if the resulting value matches the regex
                            if (!regex.test(input)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <Field name="estimation_time_type" />
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">ACTUAL TIME (HRS)</p>
                      <div className="drpdwn-slct">
                        <Field
                          name="actual_time"
                          type="text"
                          onKeyPress={(
                            event: React.KeyboardEvent<HTMLInputElement>
                          ) => {
                            const key = String.fromCharCode(event.which);
                            const input = event.currentTarget.value + key;

                            // Regular expression to allow numbers with up to 2 decimal places
                            const regex = /^\d*\.?\d{0,2}$/;

                            // Check if the resulting value matches the regex
                            if (!regex.test(input)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <Field name="actual_time_type" />
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">ESTIMATED START DATE</p>
                      <div className="drpdwn-slct">
                        <Field name="start_date">
                          {({ field }: { field: any }) => {
                            return (
                              <Calendar
                                name="start_date"
                                value={new Date(field.value)}
                                onChange={field.onChange}
                                showIcon
                                icon={"pi pi-calendar"}
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">ESTIMATED END DATE</p>
                      <div className="drpdwn-slct">
                        <Field name="due_date">
                          {({ field }: { field: any }) => {
                            return (
                              <Calendar
                                name="due_date"
                                value={new Date(field.value)}
                                onChange={field.onChange}
                                showIcon
                                icon={"pi pi-calendar"}
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">ACTUAL START DATE</p>
                      <div className="drpdwn-slct">
                        <Field name="actual_start_date">
                          {({ field }: { field: any }) => {
                            return (
                              <Calendar
                                name="actual_start_date"
                                value={new Date(field.value)}
                                onChange={field.onChange}
                                showIcon
                                icon={"pi pi-calendar"}
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">ACTUAL END DATE</p>
                      <div className="drpdwn-slct">
                        <Field name="actual_due_date">
                          {({ field }: { field: any }) => {
                            return (
                              <Calendar
                                name="actual_due_date"
                                value={new Date(field.value)}
                                onChange={field.onChange}
                                showIcon
                                icon={"pi pi-calendar"}
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        Tag
                        {errors.sprint_tag && touched.sprint_tag ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field name="sprint_tag">
                          {({ field }: { field: any }) => (
                            <input
                              {...field}
                              name="sprint_tag"
                              id="sprint_tag"
                              type="text"
                              placeholder="Enter  Tag"
                              value={values.sprint_tag}
                              onChange={field.onChange}
                            />
                          )}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex ref-tsk">
                        Reference Task{" "}
                        <span className="done material-icons-round">
                          launch
                        </span>
                      </p>
                      <div className="d-flex drpdwn-slct">
                        <span className="in-pro material-icons-round">
                          bolt
                        </span>
                        <Field name="reference_taskId">
                          {({ field }: { field: any }) => (
                            <select {...field}>
                              <option value="">Select</option>
                              {taskList?.map((task) => (
                                <option key={task._id} value={task._id}>
                                  {task.taskId} {task.name}
                                </option>
                              ))}
                            </select>
                          )}
                        </Field>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex dtls-update">
                    <div className="list-headings description">
                      <p className="d-flex">Comments {errors?.description && touched?.description ? (
                        <span style={{ color: "red" }}>*</span>
                      ) : null}</p>
                      <div className="">
                        <Editor
                          className="lst-tsk-nm"
                          id="description"
                          value={values.description}
                          onTextChange={(e) => {
                            setFieldValue("description", e.htmlValue);
                          }}
                          headerTemplate={header}
                        />
                      </div>
                    </div>
                    <div className="assignees">
                      <div className="list-headings assignees-item">
                        <p className="d-flex assignees-for">ASSIGNEES</p>
                        {!projectAssigneesReady && (
                          <SelectAssignees
                            assigneesList={projectAssignees}
                            assignees={values?.members}
                            name="member"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div></div>
                <div className=" d-flex">
                  <button
                    type="button"
                    className="btn cancel"
                    data-bs-dismiss="modal"
                    onClick={closeSidePanel}
                  >
                    Cancel
                  </button>
                  {canEditOrRemove() && (
                    <button
                      type="submit"
                      className="btn save"
                      disabled={isTaskSidePanelButtonDisabled || isSubmitting}
                    >
                      Save
                    </button>
                  )}



                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

const SubTaskSidePanel = ({
  myToast,
  subTask,
  projectId,
  taskId,
  refreshTaskList,
  closeSidePanel,
  taskDetails,
}: {
  myToast: any;
  subTask: SubTask[];
  projectId: string;
  taskId: string;
  refreshTaskList: any;
  closeSidePanel: () => void;
  taskDetails: any;
}) => {
  const [isSubTaskButtonDisabled, setIsSubTaskButton] = useState(false);
  const { projectAssignees } = useProjectAssignees(projectId);
  const [hasShownWarning, setHasShownWarning] = useState(false);

  const { taskStatus } = useTaskStatus();
console.log('taskStatus', taskStatus)
  const subTaskValidation = Yup.object({
    subTasks: Yup.array().of(
      Yup.object().shape({
        _id: Yup.string(),
        name: Yup.string().required("*"),
        assignee: Yup.object({
          _id: Yup.string().required("*"),
          profilepic: Yup.string().nullable(),
          name: Yup.string().nullable(),
        }).required("*"),
        status: Yup.object({
          _id: Yup.string(),
          name: Yup.string(),
        }),
        due_date: Yup.string(),
        estimation_time: Yup.string(),
        log_time: Yup.number(),
        description: Yup.string().required("*"),
        sprint_tag: Yup.string(),
      })
    ),
  });

  const subTaskObj = {
    name: "",
    assignee: {
      _id: "",
      profilepic: "",
      name: "UnAssigned",
    },
    status: {
      // _id: "6202607586eb533fede8c296",
      _id: "620260ab86eb533fede8c29f",
      name: "",
    },
    due_date: "",
    estimation_time: 0,
    log_time: 0,
    sprint_tag: "",
    description:"",
  };

  const subTasks = subTask.map(
    ({ _id, name, assignee, status, due_date, estimation_time, log_time, description, sprint_tag }) => ({
      _id,
      name,
      assignee,
      status,
      due_date,
      estimation_time,
      log_time,
      description,
      sprint_tag,
    })
  );

  const subTaskForm = { subTasks: [...subTasks] };

  const onSubTaskAdd = (values: any, setValues: any) => {
    const subTasks = values.subTasks;
    subTasks.push(subTaskObj);
    setValues({ ...values, subTasks });
  };

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const assgineesOptionTemplate = (option: any) => {
    return (
      <div className="d-flex sm-user-name">
        {/* <img src={option.profilepic} /> */}
        <DefaultImage
          src={option.profilepic}
          alt=""
          className=""
          letter={option.name[0]}
        />
        <div>{option.name}</div>
      </div>
    );
  };

  const selectedAssgineesTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="d-flex sm-user-name">
          {/* <img src={option.profilepic} className=""/> */}
          <DefaultImage
            src={option.profilepic}
            alt=""
            className=""
            letter={option.name[0]}
          />
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const updateOverrideTime = async (values: any) => {
    const resp = await updateSubTask(taskId, values, "true");
    if (resp.statusCode === 200) {
      showToast(
        "success",
        "Success Message",
        "Subtask updated and total Task estimation time override sucessfully!!"
      );
    }
    refreshTaskList();
    closeSidePanel();
  };

  const rejectOverrideTime = async (values: any) => {
    const resp = await updateSubTask(taskId, values, "false");
    if (resp.statusCode === 200) {
      showToast(
        "success",
        "Success Message",
        "Discard task estimated time updates sucessfully!!"
      );
    }
  };

  const canEditOrRemove = () => {
    const employeeId = localStorage.getItem("employeeId");
    const currentUserRole = localStorage.getItem('currentUserRole');
    const userId = localStorage.getItem("userId");

    const isContributor = (
      currentUserRole?.toLowerCase() === 'contributor'
    )
    const isCreator = taskDetails?.createdBy?.[0]?._id === userId;
    const isAssignee = taskDetails?.members?.some(
      (member: any) => member?._id === employeeId
    );
    // Contributor can only edit/remove if they are creator or an assignee
    if (isContributor) {
      return isCreator || isAssignee;
    }

    // Non-contributors can edit without restrictions
    return checkPermission("tasks:write");
  };

  const handleSubTaskForm = async (values: any) => {
    const { subTasks } = values;

    values.subTasks = subTasks.map((task: any) => {
      const assignee = projectAssignees
        ?.filter((person) => person._id === task.assignee._id)
        ?.reduce(
          (preValue, currValue) => {
            const { name, profilepic, _id } = currValue;
            preValue.name = name;
            preValue.profilepic = profilepic || "";
            preValue._id = _id;
            return preValue;
          },
          { name: "", profilepic: "", _id: "" }
        );
      const status = taskStatus
        ?.filter((status) => status._id === task.status._id)
        ?.reduce((preValue, currValue) => currValue);
      return {
        ...task,
        assignee,
        status,
        estimation_time: +task.estimation_time,
        log_time: task.log_time,
        sprint_tag: task?.sprint_tag,
        description:task?.description,     
      };
    });

    try {
      if (values.subTasks && values.subTasks.length > 0) {
        values.subTasks.map((items: any) => {
          const found = items.assignee?.profilepic.match(
            /\/(userprofile(.*))\?/i
          );
          if (found) {
            items.assignee.profilepic = found[1];
          }
          return items;
        });
      } else {
        values.members = [];
      }
      const resp = await updateSubTask(taskId, values, "null");

      if (resp.statusCode === 200) {
        showToast(
          "success",
          "Success Message",
          "SubTask was updated successfully."
        );
        refreshTaskList();
        closeSidePanel();
      } else if (resp.statusCode === 400) {
        confirmDialog({
          message:
            "Total task estimation time is exceeded! Do you want to override this estimation time?",
          header: "Confirmation",
          className: "mini-alert-popup-ui",
          icon: "pi pi-exclamation-circle",
          accept: () => updateOverrideTime(values),
          reject: () => rejectOverrideTime(values),
        });
      }
    } catch (error) {
      console.log(error);
    }
    setIsSubTaskButton(false);
  };

  useEffect(() => {
    if (hasShownWarning) {
      showToast("warn", "Warning", "Kindly fill the required fields!");
    }
  }, [hasShownWarning]);



  return (
    <>
      <Formik
        initialValues={subTaskForm}
        validationSchema={subTaskValidation}
        onSubmit={(values: any) => {
          setIsSubTaskButton(true);
          handleSubTaskForm(values);
        }}
      >
        {({ errors, values, touched, setValues, isSubmitting, setFieldValue }) => {
          if (Object.keys(errors).length > 0 && isSubmitting) {
            setHasShownWarning(true);
          } else {
            setHasShownWarning(false);
          }

          return (
            <Form>
              <div className="modal-body details-body">
                <div className="sub-tsk-sec">
                  <FieldArray name="subTasks">
                    {(arrayHelpers) =>
                      values.subTasks.map((task: any, index: any) => {
                        const { _id } = task;
                        return (
                          <div key={index} className="sub-task-dtls md-padding">
                            <div className="d-flex sub-tsk-nm-bx">
                              <div className="d-flex row-1">
                                <div className="d-flex sub-tsk-icon">
                                  <span className="material-icons-round in-pro">
                                    subdirectory_arrow_right
                                  </span>
                                </div>
                                <div className="d-flex tsk-id">
                                  <p>{_id}</p>
                                </div>
                                <div className="d-flex tsk-nm 3">
                                  <div className="d-flex">
                                    <span style={{ color: "red" }}>
                                      <ErrorMessage
                                        name={`subTasks.${index}.name`}
                                      />
                                    </span>
                                    <Field
                                      name={`subTasks.${index}.name`}
                                      placeholder="SubTask Name"
                                    />
                                  </div>
                                </div>
                              </div>
                              {canEditOrRemove() && (
                                <div className="d-flex rw-2-ryt">
                                  <button
                                    className={
                                      !checkPermission("tasks:write")
                                        ? "delete bg-opacity-25 bg-secondary"
                                        : "delete"
                                    }
                                    disabled={!checkPermission("tasks:write")}
                                    onClick={() => arrayHelpers.remove(index)}
                                  >
                                    <span className="material-icons-outlined">
                                      delete
                                    </span>
                                  </button>
                                </div>
                              )}

                            </div>
                            <div className="d-flex row-2">
                              <div className="d-flex rw-2-lft">
                                <div className="d-flex drpdwn-slct assig-drpdwn">
                                  <Field
                                    name={`subTasks.${index}.assignee._id`}
                                    required
                                  >
                                    {({ field }: { field: any }) => {
                                      return (
                                        <Dropdown
                                          required
                                          name={`subTasks.${index}.assignee._id`}
                                          optionLabel="name"
                                          optionValue="_id"
                                          value={field.value}
                                          onChange={field.onChange}
                                          options={projectAssignees}
                                          itemTemplate={assgineesOptionTemplate}
                                          valueTemplate={
                                            selectedAssgineesTemplate
                                          }
                                          placeholder="Select"
                                        />
                                      );
                                    }}
                                  </Field>
                                  <span style={{ color: "red" }}>
                                    <ErrorMessage
                                      name={`subTasks.${index}.assignee_id`}
                                    />
                                  </span>
                                </div>
                                <div className="d-flex drpdwn-slct status-drpdwn">
                                  <Field name={`subTasks.${index}.status._id`}>
                                    {({ field }: { field: any }) => (
                                      <select {...field}>
                                        {taskStatus?.map((status) => (
                                          <option
                                            key={status._id}
                                            value={status._id}
                                          >
                                            {status.name}
                                          </option>
                                        ))}
                                      </select>
                                    )}
                                  </Field>
                                </div>
                                <div className="d-flex drpdwn-slct dd-drpdwn">
                                  <Field name={`subTasks.${index}.due_date`}>
                                    {({ field }: { field: any }) => {
                                      return (
                                        <>
                                          <Calendar
                                            name={`subTasks.${index}.due_date`}
                                            value={new Date(field.value)}
                                            onChange={field.onChange}
                                            showIcon
                                            icon={"pi pi-calendar"}
                                            placeholder="Select Date"
                                          />
                                        </>
                                      );
                                    }}
                                  </Field>
                                </div>

                                <div className="d-flex drpdwn-slct nrml-input tks-dtls-hrs-input-group">
                                  <Field
                                    name={`subTasks.${index}.estimation_time`}
                                    placeholder="Hours"
                                    type="text"
                                    onKeyPress={(
                                      event: React.KeyboardEvent<HTMLInputElement>
                                    ) => {
                                      const key = String.fromCharCode(
                                        event.which
                                      );
                                      const input =
                                        event.currentTarget.value + key;

                                      // Regular expression to allow numbers with up to 2 decimal places
                                      const regex = /^\d*\.?\d{0,2}$/;

                                      // Check if the resulting value matches the regex
                                      if (!regex.test(input)) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                  <span style={{ color: "red" }}>
                                    <ErrorMessage
                                      name={`subTasks.${index}.estimation_time`}
                                    />
                                  </span>
                                </div>
                                <div className="d-flex drpdwn-slct nrml-input tks-dtls-hrs-input-group">
                                  <Field name={`subTasks.${index}.sprint_tag`}>
                                    {({ field }: { field: any }) => (
                                      <input
                                        {...field}
                                        name={`subTasks.${index}.sprint_tag`}
                                        id="sprint_tag"
                                        type="text"
                                        placeholder="Tag"
                                        value={values.subTasks[index]?.sprint_tag || ""}
                                        onChange={field.onChange}
                                      />
                                    )}
                                  </Field>
                                </div>
                              </div>
                            </div>

                            <div className="d-flex dtls-update">
                              <div className="list-headings description w-100">
                                {/* <p className="d-flex">Comments </p> */}
                                <div className="">
                                  <Editor
                                    className="lst-tsk-nm"
                                    id={`subTasks.${index}.description`}
                                    placeholder="Type Your comments*"
                                    value={values.subTasks[index]?.description || ""}
                                    onTextChange={(e) => {
                                      setFieldValue(`subTasks.${index}.description`, e.htmlValue);
                                    }}
                                    headerTemplate={header}
                                  />
                                  <span style={{ color: "red" }}>
                                    <ErrorMessage
                                      name={`subTasks.${index}.description`}
                                    />
                                  </span>
                                </div>
                              </div>

                            </div>
                            <div
                              className="d-flex progress-est"
                              style={{ width: "100%" }}
                            >
                              <div className="d-flex prog-est">
                                <div className="prog-bars">
                                  <div className="prog-bar full"></div>
                                  <div
                                    className="prog-bar cmplt"
                                    style={{
                                      width: `${(+task.log_time /
                                        +task.estimation_time) *
                                        100
                                        }%`,
                                    }}
                                  ></div>
                                </div>
                              </div>
                              <div
                                className="d-flex prog-dtls list-headings"
                                style={{ width: "100%" }}
                              >
                                <div
                                  className="d-flex"
                                  style={{ width: "100%" }}
                                >
                                  <div>
                                    <Field
                                      name={`subTasks.${index}.log_time`}
                                      placeholder=""
                                      style={{ width: "30px" }}
                                    />
                                    <span>&nbsp;&nbsp;HRS</span>&nbsp;/&nbsp;
                                  </div>
                                  <div>
                                    <Field
                                      name={`subTasks.${index}.estimation_time`}
                                      type="text"
                                      onKeyPress={(
                                        event: React.KeyboardEvent<HTMLInputElement>
                                      ) => {
                                        const key = String.fromCharCode(
                                          event.which
                                        );
                                        const input =
                                          event.currentTarget.value + key;

                                        // Regular expression to allow numbers with up to 2 decimal places
                                        const regex = /^\d*\.?\d{0,2}$/;

                                        // Check if the resulting value matches the regex
                                        if (!regex.test(input)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      placeholder=""
                                      style={{ width: "32px" }}
                                    />
                                    <span>HRS</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    }
                  </FieldArray>
                </div>

                {
                  canEditOrRemove() && (
                    <div className="tsk-btn">
                      <button
                        className={`d-flex ${!checkPermission("tasks:write")
                          ? "bg-opacity-25 bg-success"
                          : ""
                          }`}
                        type="button"
                        disabled={!checkPermission("tasks:write")}
                        onClick={() => onSubTaskAdd(values, setValues)}
                      >
                        <span className="material-icons-round">add</span>
                        <p>Sub Task</p>
                      </button>
                    </div>
                  )
                }

              </div>
              <div className="modal-footer">
                <div></div>
                <div className="d-flex">
                  <button
                    type="button"
                    className="btn cancel"
                    data-bs-dismiss="modal"
                    onClick={closeSidePanel}
                  >
                    Cancel
                  </button>
                  {
                    canEditOrRemove() && (
                      <button
                        type="submit"
                        className={`btn save ${!checkPermission("tasks:write")
                          ? "bg-opacity-25 bg-success"
                          : ""
                          }`}
                        disabled={
                          isSubTaskButtonDisabled ||
                          isSubmitting ||
                          !checkPermission("tasks:write")
                        }
                      >
                        Save
                      </button>
                    )
                  }

                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

const InfoSidePanel = ({
  createdAt,
  createdBy,
  subTask,
  projectId,
  taskId,
  refreshTaskList,
}: {
  createdAt: string | undefined;
  createdBy: string | undefined;
  subTask: SubTask[];
  projectId: string;
  taskId: string;
  refreshTaskList: () => void;
}) => {

  const { taskHistoryData, refetch } = useTaskHistoryById(taskId);
  useEffect(() => {
    if (taskId) {
      refetch();
    }
  }, [taskId, refetch]);

  const taskHistoryDataResponse = taskHistoryData?.result?.result;
  const { taskStatus, isLoading, isError } = useTaskStatus();
  const formatChange = (change: any) => {
    const field = change?.field?.toLowerCase();
    let cleanNewValue = change?.newValue ?? "NA";
    let cleanOldValue = change?.oldValue ?? "NA";

    const fieldName =
      field === "description"
        ? "Comments"
        : field.replace(/_/g, " ").replace(/\b\w/g, (char: any) => char.toUpperCase());


    // Handle sprint_tag formatting
    if (field === "sprint_tag") {
      return `Sprint Tag changed to ${cleanNewValue}`;
    }

    if (field === "actual_time") {
      return `Actual Time  changed to ${cleanNewValue} hr`;
    }

    if (field === "estimate_time") {
      return `Estimate Time changed to ${cleanNewValue} hr`;
    }

    // Beautify date values
    const isDate = (value: any) => typeof value === "string" && !isNaN(Date.parse(value));

    if (isDate(cleanNewValue)) cleanNewValue = dateBeautify(new Date(cleanNewValue));
    if (isDate(cleanOldValue)) cleanOldValue = dateBeautify(new Date(cleanOldValue));



    // Convert status ID to name
    if (field === "status" && Array.isArray(taskStatus)) {
      const getStatusName = (id: string) => {
        const statusObj = taskStatus.find((status: any) => status?._id === id);
        return statusObj ? statusObj?.name : "Unknown Status ";
      };

      cleanNewValue = getStatusName(cleanNewValue);
      cleanOldValue = getStatusName(cleanOldValue);
    }

    // Handle members field (fixing empty value)
    if (field === "members") {
      cleanNewValue =
        Array.isArray(cleanNewValue) && cleanNewValue.length > 0
          ? cleanNewValue.map((member: any) => member.name).join(", ")
          : "NA";

      cleanOldValue =
        Array.isArray(cleanOldValue) && cleanOldValue.length > 0
          ? cleanOldValue.map((member: any) => member.name).join(", ")
          : "NA";
    }



    // Handle assignee changes
    if (field.includes("assignee")) {
      cleanOldValue = cleanOldValue !== "NA" ? cleanOldValue?.name : "UnAssigned";
      cleanNewValue = cleanNewValue !== "NA" ? cleanNewValue?.name : "UnAssigned";
      return `Assignee changed  to ${cleanNewValue}`;
    }

    // Handle description changes (strip HTML)
    if (field.includes("description")) {
      cleanOldValue = cleanOldValue !== "NA" ? cleanOldValue.replace(/<\/?[^>]+(>|$)/g, "") : "NA";
      cleanNewValue = cleanNewValue !== "NA" ? cleanNewValue.replace(/<\/?[^>]+(>|$)/g, "") : "NA";
      return `Description changed  to "${cleanNewValue}"`;
    }


    // Format estimation time
    if (field.includes("estimation_time")) {
      cleanNewValue = `${cleanNewValue} hr`;
    }

    // Special handling for task creation & subtask creation
    if (field === "taskcreation" || field === "subtaskcreation" || field === "subtaskCreation" || field === "taskCreation") {
      return `${cleanNewValue}`;
    }


    // Handle subTask status change
    if (field.includes("subtasks") && cleanNewValue && cleanOldValue) {
      if (cleanNewValue?.name && cleanOldValue?.name) {
        return `Subtask Status changed  to ${cleanNewValue?.name}`;
      }
    }


    // Handle subtasks (Fixing [object Object])
    if (field === "subtasks") {
      cleanNewValue =
        Array.isArray(cleanNewValue) && cleanNewValue.length > 0
          ? cleanNewValue.map((task: any) => task.name).join(", ")
          : "NA";

      cleanOldValue =
        Array.isArray(cleanOldValue) && cleanOldValue.length > 0
          ? cleanOldValue.map((task: any) => task.name).join(", ")
          : "NA";

      return `Subtasks changed to ${cleanNewValue}`;
    }

    // Handling deleted fields
    if (field.includes(".deleted")) {
      return `${cleanNewValue}  was deleted `;
    }




    return `${fieldName} changed  to ${cleanNewValue}`;
  };

  return (
    <div className="details-body details-activities-block">
      <div className="details-activities-wrap">
        <div className="details-activities-item">



          {/* <div className="task-activity-group">
            <div className="activity-date">
              <div className="date-separate"> </div>
              </div>
              </div> */}





          {taskHistoryDataResponse?.length > 0 && (
            <div className="task-history-section">
              <h4>Task History</h4>
              {taskHistoryDataResponse.map((history: any, index: any) => (
                <div
                  key={index}
                  className="task-history-item"
                  style={{
                    borderBottom: "1px solid #ddd",
                    marginBottom: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  {/* <hr /> */}
                  <p>
                    {history.changes.map(formatChange).join(" ; ")} {" "}
                    {/* by{" "}
                    {history?.updatedBy?.[0]?.name || history?.createdBy?.[0]?.name || "Unknown"}  */}
                    on{" "}
                    {dateBeautify(new Date(history.updatedAt))}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
        {/* <div className="details-activites-item">
          <h4>Task Created ON: </h4>
          <p>{dateBeautify(createdAt)}</p>
        </div>
        <div className="details-activites-item">
          <h4>Task Created BY</h4>
          <p>{createdBy}</p>
        </div> */}
      </div>
    </div>
  );
};

const TaskProgress = ({
  name,
  workTime,
  estimationTime,
  taskLogTime,
}: {
  name: string;
  workTime: string;
  estimationTime: number;
  taskLogTime: number;
}) => {
  //   console.log({ name, workTime, estimationTime, taskLogTime });

  const {
    values: { taskId, subTask },
    setFieldValue,
  } = useFormikContext<any>();

  const { taskEstimation, isLoading } = useTaskEstimation(taskId, subTask);

  useEffect(() => {
    let ignore = true;
    if (!!taskEstimation && ignore) {
      setFieldValue(name, taskEstimation.estimation_time);
      // console.log('taskEstimation.estimation_time ::', taskEstimation.estimation_time)
    }

    return () => {
      ignore = false;
    };
  }, [taskEstimation]);

  const totalTime = (+workTime + +taskLogTime).toFixed(2);

  return (
    <div className="progress-est">
      {
        <div className="d-flex prog-dtls list-headings">
          <p className="d-flex">Task Progress</p>
          <p>
            {/* <span>{`${+workTime + +taskLogTime} hrs`}</span>&nbsp; / &nbsp; */}
            <span>{`${totalTime} hrs`}</span>&nbsp; / &nbsp;
            <span>{`${estimationTime} hrs`}</span>
          </p>
        </div>
      }
      {
        <div className="prog-bars">
          <div className="prog-bar full"></div>
          <div
            className="prog-bar cmplt"
            style={{
              width: `${((+workTime + +taskLogTime) / +estimationTime) * 100}%`,
            }}
          ></div>
        </div>
      }
    </div>
  );
};

const SubTaskProgress = ({
  name,
  workTime,
  estimationTime,
}: {
  name: string;
  workTime: string;
  estimationTime: string;
}) => {
  const {
    values: { taskId, subTask },
    setFieldValue,
  } = useFormikContext<any>();

  const { taskEstimation, isLoading } = useTaskEstimation(taskId, subTask);

  useEffect(() => {
    let ignore = true;
    if (!!taskEstimation && ignore) {
      setFieldValue(name, taskEstimation.estimation_time);
      // console.log('taskEstimation.estimation_time ::', taskEstimation.estimation_time)
    }

    return () => {
      ignore = false;
    };
  }, [taskEstimation]);

  return (
    <div className="progress-est">
      <div className="d-flex prog-dtls list-headings">
        <p className="d-flex">SubTask Progress</p>
        <p>
          <span>{`${workTime} hrs`}</span>&nbsp; / &nbsp;
          <span>{`${estimationTime} hrs`}</span>
        </p>
      </div>
      <div className="prog-bars">
        <div className="prog-bar full"></div>
        <div
          className="prog-bar cmplt"
          style={{ width: `${(+workTime / +estimationTime) * 100}%` }}
        ></div>
      </div>
    </div>
  );
};

const TimeHourToggle = (props: any) => {
  const [toggle, setToggle] = useState("hour");

  const {
    values: { starttime, endtime },
    setFieldValue,
  } = useFormikContext<any>();

  const [field, meta] = useField(props);
};

const TimeLogModal = ({
  myToast,
  visible,
  onHide,
  projectId,
  taskEstimation,
  taskLogTime,
  selectedAssignee,
  selectedStatus,
  selectedSprint,
  closeSidePanel,
  selectedSort,
  taskId,
  subTasks,
  refreshTaskList,
}: {
  visible: boolean;
  onHide: () => void;
  projectId: string | undefined;
  taskEstimation: number;
  taskLogTime: number;
  closeSidePanel: () => void;
  selectedAssignee: string;
  selectedStatus: string;
  selectedSort: string;
  selectedSprint: string;
  taskId: string | undefined;
  subTasks: SubTask[];
  refreshTaskList: any;
  myToast: any;
}) => {
  const [isSaveHrButtonDisabled, setIsSaveHrButtonDiabled] = useState(false);
  const [toggle, setToggle] = useState("hour");

  const [startTime, setStartTime] = useState();
  const [hasShownWarning, setHasShownWarning] = useState(false);

  const { userProjects } = useUserProjects();

  const { taskList } = useTaskList(
    projectId,
    selectedAssignee,
    selectedStatus,
    selectedSort,
    selectedSprint,
  );

  let taskDropDownList: any[] | undefined;

  if (taskList) {
    taskDropDownList = taskList.map(({ _id, taskId, name }) => {
      return { _id, name: taskId.concat(" " + name) };
    });
  }

  let subTaskList: any[] | undefined;

  if (subTasks) {
    subTaskList = subTasks.map(({ _id, name }) => {
      return { _id, name: _id.concat(" " + name) };
    });
  }

  const logTimeForm = {
    projectId,
    taskId,
    subTask: "None",
    workDate: "",
    istimehours: true,
    totalhours: "0",
    starttime: moment(),
    endtime: moment(),
    comments: "",
    estimation: "",
  };

  const logTimeValidation = Yup.object({
    projectId: Yup.string().required("*"),
    taskId: Yup.string().required("*"),
    subTask: Yup.string(),
    workDate: Yup.string().required("*"),
    istimehours: Yup.string().required("*"),
    totalhours: Yup.string().required("*"),
    starttime: Yup.string(),
    endtime: Yup.string(),
    comments: Yup.string().required("*"),
  });

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const handleTimeLogForm = async (values: any) => {
    if (values.istimehours) {
      values.starttime = "";
      values.endtime = "";
    } else {
    }

    const {
      projectId,
      taskId,
      subTask,
      workDate,
      istimehours,
      totalhours,
      starttime,
      endtime,
      comments,
      estimation,
    } = values;

    // Adjust the workDate to UTC before conversion
    const localDate = new Date(workDate);
    const utcDate = new Date(
      localDate.getTime() - localDate.getTimezoneOffset() * 60000
    );
    const formattedWorkDate = utcDate.toISOString(); // Get the ISO format
    try {
      const resp = await createLogTime({
        projectId,
        taskId,
        subTask,
        workDate: formattedWorkDate,
        istimehours,
        totalhours,
        starttime,
        endtime,
        comments,
        estimation,
      });
      if (resp.statusCode === 201) {
        showToast(
          "success",
          "Success Message",
          "LogTime was created successfully."
        );
      }
    } catch (error) {
      console.log(error);
    }
    refreshTaskList();
    onHide();
    closeSidePanel();
    setIsSaveHrButtonDiabled(false);
  };

  const handleTimeRangeHours = (setFieldValue: any) => (e: any) => {
    const duration = moment.duration(e.endTime.diff(e.startTime));
    const hours = duration.asHours();

    setFieldValue("totalhours", hours);
  };
  useEffect(() => {
    if (hasShownWarning) {
      showToast("warn", "Warning", "Kindly fill the required fields!");
    }
  }, [hasShownWarning]);

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      style={{ width: "50vw" }}
      header="Log Time"
    >
      <Formik
        initialValues={logTimeForm}
        validationSchema={logTimeValidation}
        onSubmit={async (values) => {
          setIsSaveHrButtonDiabled(true);
          await handleTimeLogForm(values);
        }}
      >
        {({ values, errors, touched, setFieldValue, isSubmitting }) => {
          // Show warning when there are errors and the form is being submitted
          if (Object.keys(errors).length > 0 && isSubmitting) {
            setHasShownWarning(true);
          } else {
            setHasShownWarning(false);
          }
          return (
            <Form>
              <div className="modal-body">
                <div className="log-tsk">
                  {/* <p className="log-tsk-hd">Tasks</p> */}
                  <div className="lst-tsk-nm dtls-update">
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        project
                        {errors.projectId && touched.projectId ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="d-flex drpdwn-slct task-cl">
                        <span className="material-icons-outlined">
                          fiber_manual_record
                        </span>
                        <Field name="projectId">
                          {({ field }: { field: any }) => {
                            return (
                              <Dropdown
                                disabled
                                name="projectId"
                                optionLabel="project_name"
                                optionValue="_id"
                                value={field.value}
                                onChange={field.onChange}
                                options={userProjects}
                                placeholder="Select"
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        task
                        {errors.taskId && touched.taskId ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="d-flex drpdwn-slct">
                        <span className="in-pro material-icons-round">
                          bolt
                        </span>
                        <Field name="taskId">
                          {({ field }: { field: any }) => {
                            return (
                              <Dropdown
                                disabled
                                name="taskId"
                                optionLabel="name"
                                optionValue="_id"
                                value={field.value}
                                onChange={field.onChange}
                                options={taskDropDownList}
                                placeholder="Select"
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">sub task</p>
                      <div className="d-flex drpdwn-slct">
                        <span className="in-review material-icons-round">
                          subdirectory_arrow_right
                        </span>
                        <Field name="subTask">
                          {({ field }: { field: any }) => {
                            return (
                              <Dropdown
                                name="subTask"
                                optionLabel="name"
                                optionValue="_id"
                                value={field.value}
                                onChange={field.onChange}
                                options={subTaskList}
                                placeholder="Select"
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        date
                        {errors.workDate && touched.workDate ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field name="workDate">
                          {({ field }: { field: any }) => (
                            <Calendar
                              name="workDate"
                              value={field.value}
                              onChange={field.onChange}
                              showIcon
                              icon={"pi pi-calendar"}
                            />
                          )}
                        </Field>
                      </div>
                    </div>

                    <div className="d-flex list-headings">
                      <p className="d-flex drpdwn-slct">
                        {errors.totalhours && touched.totalhours ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                        <select
                          value={toggle}
                          onChange={(e) => setToggle(e.target.value)}
                        >
                          <option value="hour">HOURS</option>
                          {/* <option value="time">TIME</option> */}
                        </select>
                      </p>
                      {toggle === "hour" ? (
                        <div className="drpdwn-slct">
                          <Field
                            name="totalhours"
                            type="text"
                            onKeyPress={(
                              event: React.KeyboardEvent<HTMLInputElement>
                            ) => {
                              const key = String.fromCharCode(event.which);
                              const input = event.currentTarget.value + key;

                              // Regular expression to allow numbers with up to 2 decimal places before and after dot
                              const regex = /^\d{0,2}(\.\d{0,2})?$/;

                              // Check if the resulting value matches the regex
                              if (!regex.test(input)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </div>
                      ) : (
                        <div className="drpdwn-slct">
                          <TimeRange
                            startMoment={values.starttime}
                            endMoment={values.endtime}
                            onStartTimeChange={(e: any) => {
                              setFieldValue("starttime", e.starttime);
                            }}
                            onEndTimeChange={(e: any) => {
                              setFieldValue("endtime", e.endtime);
                            }}
                            onChange={handleTimeRangeHours(setFieldValue)}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {values.subTask && values.subTask !== "None" ? (
                  <SubTaskProgress
                    name="estimation"
                    workTime={values.totalhours}
                    estimationTime={values.estimation}
                  />
                ) : (
                  <TaskProgress
                    name="estimation"
                    workTime={values.totalhours}
                    estimationTime={taskEstimation}
                    taskLogTime={taskLogTime}
                  />
                )}

                <div className="notes list-headings">
                  <p className="d-flex">Notes {errors?.comments && touched?.comments ? (
                    <span style={{ color: "red" }}>*</span>
                  ) : null}</p>
                  <div className="note-box">
                    <Field name="comments">
                      {({ field }: { field: any }) => (
                        <Editor
                          id="comments"
                          value={values.comments}
                          onTextChange={(e) =>
                            setFieldValue("comments", e.htmlValue)
                          }
                          headerTemplate={header}
                        />
                      )}
                    </Field>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <div></div>
                <div className=" d-flex">
                  <button
                    type="button"
                    className="btn cancel log-cncl"
                    onClick={onHide}
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn save log-sve"
                    disabled={isSaveHrButtonDisabled || isSubmitting}
                  >
                    Save<span>&nbsp;({values.totalhours} Hours)</span>
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

const confirmDeleteTask = (
  myToast: any,
  refreshTaskList: any,
  taskId: string,
  closeSidePanel: () => void
) => {
  confirmDialog({
    message: "Do you want to delete this record?",
    header: "Confirmation",
    className: "mini-alert-popup-ui",
    icon: "pi pi-exclamation-circle",
    accept: () => taskOnDelete(taskId),
    // reject: () => handleTeamShow()
  });

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const taskOnDelete = async (taskId: string) => {
    try {
      const resp = await deleteTask(taskId);
      if (resp.status === 200) {
        showToast(
          "success",
          "Success Message",
          "Task was deleted successfully."
        );
      }
      refreshTaskList();
    } catch (error) {
      console.log(error);
    }
    closeSidePanel();
  };
};

const DeleteTask = ({
  myToast,
  taskId,
  closeSidePanel,
  refreshTaskList,
}: {
  myToast: any;
  refreshTaskList: any;
  taskId: string;
  closeSidePanel: () => void;
}) => {


  return (
    <button
      className={
        !checkPermission("tasks:write")
          ? "delete bg-opacity-25 bg-secondary"
          : "delete"
      }
      disabled={!checkPermission("tasks:write")}
      onClick={() =>
        confirmDeleteTask(myToast, refreshTaskList, taskId, closeSidePanel)
      }
    >
      <span className="material-icons-outlined">delete</span>
    </button>
  );
};

const SidePanel = ({
  myToast,
  enableSidePanel,
  taskDetails,
  closeSidePanel,
  projectId,
  selectedAssignee,
  selectedStatus,
  selectedSort,
  selectedSprint,
  refreshTaskList,
  activeIndex,
  setActiveIndex,

}: {
  myToast: any;
  taskDetails: TaskType;
  closeSidePanel: () => void;
  enableSidePanel: boolean;
  projectId: string | undefined;
  selectedAssignee: string;
  selectedStatus: string;
  selectedSprint: string;
  selectedSort: string;
  refreshTaskList: any;
  activeIndex: number;
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
}) => {

  const [showTimeLog, setShowTimeLog] = useState(false);

  const canEditOrRemove = () => {
    const employeeId = localStorage.getItem("employeeId");
    const currentUserRole = localStorage.getItem('currentUserRole');
    const userId = localStorage.getItem("userId");

    const isContributor = (
      currentUserRole?.toLowerCase() === 'contributor'
    )
    const isCreator = taskDetails?.createdBy?.[0]?._id === userId;
    const isAssignee = taskDetails?.members?.some(
      (member) => member?._id === employeeId
    );
    if (isContributor) {
      return isCreator || isAssignee;
    }

    return checkPermission("tasks:write");
  };

  const canRemove = () => {
    const employeeId = localStorage.getItem("employeeId");
    const currentUserRole = localStorage.getItem('currentUserRole');
    const userId = localStorage.getItem("userId");

    const isContributor = (
      currentUserRole?.toLowerCase() === 'contributor'
    )
    const isCreator = taskDetails?.createdBy?.[0]?._id === userId;
    const isAssignee = taskDetails?.members?.some(
      (member) => member?._id === employeeId
    );
    if (isContributor) {
      return isCreator && isAssignee;
    }

    return checkPermission("tasks:write");
  };


  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };
  return (
    <div className={`tsk-vw-dtls ${enableSidePanel ? "show" : null}`}>
      <div className="modal-header">
        <div className="d-flex modal-title" id="">
          <span className="tsk-icon material-icons-round">bolt</span>
          <p className="tsk-id">{taskDetails.taskId}</p>
        </div>

        <div className="d-flex cpy-del-cls">
          {
            canEditOrRemove() && (
              <button
                className={`d-flex add-time ${!checkPermission("tasks:write") ? "bg-opacity-25" : ""
                  }`}
                type="button"
                disabled={!checkPermission("tasks:write")}
                onClick={() => setShowTimeLog(true)}
              >
                <span className="material-icons-round">add</span>
                <p>Time</p>
              </button>
            )
          }
          {
            canEditOrRemove() && (
              <div className="cnt-copy">
                <button
                  className="d-flex"
                  onClick={() => showToast("warn", "", "Coming soon...")}
                >
                  <span className="material-icons-round">content_copy</span>
                  <p>Copy Link</p>
                </button>
              </div>
            )
          }

          {
            canEditOrRemove() && (
              <DeleteTask
                myToast={myToast}
                taskId={taskDetails._id}
                closeSidePanel={closeSidePanel}
                refreshTaskList={refreshTaskList}
              />
            )
          }

          <button type="button" onClick={closeSidePanel}>
            <span className="material-icons-round">close</span>
          </button>
        </div>
      </div>

      <div className="modal-body">
        <div className="progress-est">
          <div className="d-flex prog-dtls list-headings">
            <p className="d-flex">overall &nbsp;progress</p>
            <p>
              <span>{taskDetails.log_time} hrs</span> /{" "}
              <span>{taskDetails.estimation_time} hrs</span>
            </p>
          </div>
          {taskDetails.log_time <= taskDetails.estimation_time ? (
            <div className="prog-bars">
              <div className="prog-bar full"></div>
              <div
                className="prog-bar cmplt"
                style={{
                  width: `${(+taskDetails.log_time / +taskDetails.estimation_time) * 100
                    }%`,
                }}
              ></div>
            </div>
          ) : (
            <div className="prog-bars">
              <div className="prog-bar full"></div>
              <div
                className="prog-bar cmplt full"
                style={{
                  width: `${(+taskDetails.log_time / +taskDetails.estimation_time) * 100
                    }%`,
                }}
              ></div>
            </div>
          )}
        </div>
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          <TabPanel header="DETAILS">
            <TaskSidePanel
              taskDetails={taskDetails}
              selectedAssignee={selectedAssignee}
              selectedStatus={selectedStatus}
              selectedSort={selectedSort}
              selectedSprint={selectedSprint}
              closeSidePanel={closeSidePanel}
              refreshTaskList={refreshTaskList}
              myToast={myToast}
            />
          </TabPanel>
          <TabPanel header={`SUB TASK(${taskDetails?.subTasks?.length})`}>

            <SubTaskSidePanel
              myToast={myToast}
              closeSidePanel={closeSidePanel}
              taskId={taskDetails._id}
              subTask={taskDetails.subTasks}
              projectId={taskDetails.projectId}
              refreshTaskList={refreshTaskList}
              taskDetails={taskDetails}

            />
          </TabPanel>
          <TabPanel header="DOCUMENTS" disabled={true}></TabPanel>
          <TabPanel header="ACTIVITES">
            <InfoSidePanel
              createdAt={taskDetails?.createdAt}
              createdBy={taskDetails?.createdBy}
              taskId={taskDetails._id}
              subTask={taskDetails.subTasks}
              projectId={taskDetails.projectId}
              refreshTaskList={refreshTaskList}
            />
          </TabPanel>
        </TabView>
      </div>
      <TimeLogModal
        myToast={myToast}
        visible={showTimeLog}
        onHide={() => setShowTimeLog(false)}
        projectId={projectId}
        selectedAssignee={selectedAssignee}
        selectedStatus={selectedStatus}
        selectedSprint={selectedSprint}
        closeSidePanel={closeSidePanel}
        selectedSort={selectedSort}
        taskId={taskDetails._id}
        taskEstimation={taskDetails.estimation_time}
        taskLogTime={taskDetails.log_time}
        subTasks={taskDetails.subTasks}
        refreshTaskList={refreshTaskList}
      />
    </div>
  );
};

const TaskFilterList = ({
  isTaskLoading,
  isTaskListError,
  taskList,
  openSidePanel,
  setActiveIndex,
}: {
  isTaskLoading: any;
  isTaskListError: any;
  taskList: TaskType[] | undefined;
  openSidePanel: (task: TaskType) => void;
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
}) => {
  if (isTaskLoading || isTaskListError) {
    return <DataLoading />;
  }
  return (
    <div className="tsk-lists-wrap">
      <div className="tsk-lists ">
        {taskList && taskList.length > 0 ? (
          <TaskList
            taskList={taskList}
            openSidePanel={openSidePanel}
            setActiveIndex={setActiveIndex}
          />
        ) : (
          <div className="tsk-lists empty-screen-wrap">
            <div className="card-ui">
              <div className="icon-block-wrap">
                {" "}
                <span className="tsk-icon material-icons-round">
                  ramen_dining
                </span>{" "}
              </div>
              <h3>Look like there’s currently nothing to see here</h3>
              <p> No results were found. Request to add task. </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

function Task() {
  const [selectedProject, setSelectedProject] = useState<string>();
  const [selectedProjectName, setSelectedProjectName] = useState<string>();
  const [selectedStatus, setSelectedStatus] = useState<any>([]);
  const [selectedSort, setSelectedSort] = useState("Default");
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedAssignee, setSelectedAssignee] = useState<any>([]);
  const [selectedSprint, setSelectedSprint] = useState<any>([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [projectShow, setProjectShow] = useState(false);
  const [projectDetailsShow, setProjectDetailsShow] = useState(false);
  const handleProjectClose = () => setProjectShow(false);
  const handleProjectShow = () => setProjectShow(true);
  const handleProjectDetailsShow = () => setProjectDetailsShow(true);
  const handleProjectDetailsClose = () => setProjectDetailsShow(false);
  const [showList, setShowOption] = useState(true);
  const [enableSidePanel, setEnableSidePanel] = useState(false);
  const [taskDetails, setTaskDetails] = useState<TaskType>({} as TaskType);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isProjectUpdate, setIsProjectUpdate] = useState(false);

  const openSidePanel = (task: TaskType) => {
    setEnableSidePanel(true);
    setTaskDetails(task);
  };

  const closeSidePanel = () => {
    setEnableSidePanel(false);
    setActiveIndex(0);
  };

  const handleSprintChange = (event: any) => {
    setSelectedSprint(event.value);
  };

  // useEffect to automatically close side panel when selectedProjectName changes
  useEffect(() => {
    if (selectedProjectName) {
      closeSidePanel(); // Close side panel when selectedProjectName changes
    }
  }, [selectedProjectName]);

  const { projectsList, isProjectLoading, projectListMutate } =
    useProjectsList();

  const { taskList, isTaskLoading, isTaskListError, taskMutate } = useTaskList(
    selectedProject,
    selectedAssignee?.join(","),
    selectedStatus?.join(","),
    selectedSort,
    selectedSprint?.join(","),
  );


  const { projectId } = useParams();
  const { projectName } = useParams();

  useEffect(() => {
    if (projectsList) {
      if (projectId) {
        setSelectedProject(projectId);

        const data = projectsList?.map((value: any) => value?.data);
        const res = data?.map((project: any) => project?.projects);
        const project = res.flat().find((item) => item?._id === projectId);
        setSelectedProjectName(project?.name);
      } else {
        const projects = projectsList?.[0]?.projects?.[0];
        setSelectedProject(projects?._id);
        setSelectedProjectName(projects?.name);
      }
    }
  }, []);

  let projectForm: ProjectForm = {
    _id: "",
    project_name: "",
    project_tag: "",
    client: "",
    duration: "",
    duration_type: "",
    due_date: "",
    status: "",
    project_type: "",
    description: "",
    manager: "",
    leader: "",
    techLeader: "",
    estimate_start_date: "",
    estimate_end_date: "",
    actual_start_date: "",
    actual_end_date: "",
    estimate_time: "",
    actual_time: "",
    estimate_time_type: "",
    actual_time_type: "",
    sprint_tag: "",
    contributors: [],
    assignees_visibility: false,
    contributor: "",
  };
  const [projectFields, setProjectForms] = useState(projectForm);

  const { projectDetails, isProjectMutate } =
    useProjectDetails(selectedProject);
  const { taskHistoryData, isLoading, isError } = useTaskHistoryById(taskDetails?._id);


  useEffect(() => {
    if (taskDetails?._id) {
      console.log("Task history updated:", taskHistoryData);
    }
  }, [taskHistoryData]);

  const taskHistory = taskHistoryData?.result?.result
  const { taskListTotal } = useTaskListTotal(selectedProject);

  const myToast = useRef(null);

  const [permissions, setPermissions] = useState<string[]>([]);
  const [role, setRole] = useState<string>("");
  const [user, setUser] = useState<string>("");

  useEffect(() => {
    _getPermissions();
  }, []);

  const _getPermissions = async () => {
    let token = await getPermissionsList();
    setRole(token.login_user?.role);
    setUser(token.login_user?._id);
    setPermissions(token?.permissions);
    setRole(token.login_user.role);
  };

  return (
    <>
      <Nav
        role={role}
        user={user}
        projectsList={projectsList}
        isProjectLoading={isProjectLoading}
        selectProject={setSelectedProject}
        selectProjectName={setSelectedProjectName}
        createProject={handleProjectShow}
        projectId={selectedProject}
        setInputField={setProjectForms}
        setIsProjectUpdate={setIsProjectUpdate}
        permissions={permissions}
        setSelectedSort={setSelectedSort}
        setSelectedStatus={setSelectedStatus}
        setSelectedAssignee={setSelectedAssignee}
      />

      <ProjectModal
        myToast={myToast}
        permissions={permissions}
        selectProject={setSelectedProject}
        projectShow={projectShow}
        handleProjectClose={handleProjectClose}
        isProjectUpdate={isProjectUpdate}
        setInputField={setProjectForms}
        isProjectMutate={isProjectMutate}
        inputField={projectFields}
        projectListMutate={projectListMutate}
        setSelectedOption={setSelectedOption}
        role={role}
      />

      <ProjectDetailsModel
        myToast={myToast}
        permissions={permissions}
        selectProject={setSelectedProject}
        projectDetailsShow={projectDetailsShow}
        handleProjectClose={handleProjectClose}
        isProjectUpdate={isProjectUpdate}
        setInputField={setProjectForms}
        isProjectMutate={isProjectMutate}
        inputField={projectFields}
        projectListMutate={projectListMutate}
        setSelectedOption={setSelectedOption}
        role={role}
        handleProjectDetailsClose={handleProjectDetailsClose}
      />

      <Toast ref={myToast} />

      {projectsList?.length === 0 ? (
        <DataEmpty
          headerText={"Look like there’s currently nothing to see here"}
          contentText={"No results were found. Request to add projects."}
        />
      ) : (
        <div className="task-top-table-separate">
          <div className="mn-dtls-vw container">
            <ProjectHeader
              role={role}
              projectName={selectedProjectName}
              totalTask={taskListTotal}
              showList={showList}
              setShowOption={setShowOption}
              createTask={handleShow}
              selectOption={selectedOption}
              updateSelectOption={setSelectedOption}
              projectShow={handleProjectShow}
              projectDetails={projectDetails}
              projectDetailsShow={handleProjectDetailsShow}
              setIsProjectUpdate={setIsProjectUpdate}
              setInputField={setProjectForms}
              myToast={myToast}
            />
            <div className="dtls-mn-sec">
              <TaskFilters
                projectId={selectedProject}
                selectAssignee={selectedAssignee}
                updateSelectAssignee={setSelectedAssignee}
                selectStatus={selectedStatus}
                selectSort={selectedSort}
                updateSelectStatus={setSelectedStatus}
                updateSelectSort={setSelectedSort}
                taskList={taskList}
                selectSprint={selectedSprint}
                updateSelectSprint={setSelectedSprint}
              />
            </div>
            <TaskFilterList
              isTaskLoading={isTaskLoading}
              isTaskListError={isTaskListError}
              taskList={taskList}
              openSidePanel={openSidePanel}
              setActiveIndex={setActiveIndex}
            />
          </div>
        </div>
      )}
      <CreateTaskModal
        show={show}
        projectId={selectedProject}
        myToast={myToast}
        selectedAssignee={selectedAssignee.join(",")}
        selectedStatus={selectedStatus.join(",")}
        selectedSort={selectedSort}
        selectedSprint={selectedSprint.join(",")}
        handleClose={handleClose}
        refreshTaskList={taskMutate}
        role={role}
      />

      <SidePanel
        myToast={myToast}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        enableSidePanel={enableSidePanel}
        closeSidePanel={closeSidePanel}
        taskDetails={taskDetails}
        projectId={selectedProject}
        selectedAssignee={selectedAssignee.join(",")}
        selectedStatus={selectedStatus.join(",")}
        selectedSprint={selectedSprint.join(",")}
        selectedSort={selectedSort}
        refreshTaskList={taskMutate}
      />
    </>
  );
}
export default Task;
